import Typography from "@mui/material/Typography";
import * as React from "react";
import BackButton from "../../containers/BackButton";
import Breadcrumbs from "../../containers/Breadcrumbs";
import { useInitialPageLoad } from "../../hooks/useInitialPageLoad";
import CloudFoundryBanner from "../../containers/CloudFoundryBanner";

export default function HelpContentCB() {
  useInitialPageLoad("historical");
  return (
    <>
      <Breadcrumbs currentPageBreadCrumbTitle="Historical Bank Data" />
      <CloudFoundryBanner />
      <BackButton
        app="Historical"
        buttonLabel="Back to Search Results"
        variant="dark"
      />
      <>
        <Typography variant="h1" id="historical-cb-help-title">
          Commercial Banks Help
        </Typography>

        <Typography variant="body2" component="div">
          <a href="#INTRODUCTION">INTRODUCTION</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#CONTENTS">CONTENTS</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#DATA SOURCES">DATA SOURCES</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#METHODOLOGY">METHODOLOGY</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#COMPARABILITY OF DATA">COMPARABILITY OF DATA</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#LEVEL OF CONSOLIDATION">LEVEL OF CONSOLIDATION</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#VALIDATION">VALIDATION</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#EXCLUSIONS">EXCLUSIONS</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#DEFINITIONS">DEFINITIONS</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#FDIC-Insured Institutions">FDIC-Insured Institutions</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Charter Class">Charter Class</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Charter Type">Charter Type</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#All Charters">All Charters</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Insured Commercial Banks">Insured Commercial Banks</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Insured Savings Institutions">
            Insured Savings Institutions
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Insured Branches of Foreign Banks">
            Insured Branches of Foreign Banks
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Effective Date">Effective Date</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#FDIC-Insured Commercial Banks">
            FDIC-Insured Commercial Banks
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#National banks">National banks</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#FDIC-Insured Savings Institutions">
            FDIC-Insured Savings Institutions
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Cert">Cert</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Failure/Assistance">Failure/Assistance</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Estimated Loss">Estimated Loss</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Insurance Fund">Insurance Fund</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#FIN">FIN</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#State">State</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Location">Location</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#nstitution Name">Institution Name</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Total Assets">Total Assets</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Total Deposits">Total Deposits</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#ransaction Types">Transaction Types</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#COMMENTS, SUGGESTIONS AND REQUESTS">
            COMMENTS, SUGGESTIONS AND REQUESTS
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#DATA AVAILABILITY">DATA AVAILABILITY</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Number of Institutions, Branches and Total Offices">
            Number of Institutions, Branches and Total Offices
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Origin of the FDIC">Origin of the FDIC</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Commercial Banks - Original Definitions">
            Commercial Banks - Original Definitions
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Commercial Banks - Changes to the Definitions">
            Commercial Banks - Changes to the Definitions
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Offices and Branches - Changes to the Definitions">
            Offices and Branches - Changes to the Definitions
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Changes in Number of Institutions">
            Changes in Number of Institutions
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Number of Unit Institutions and Institutions with Branches">
            Number of Unit Institutions and Institutions with Branches
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Net Income">Net Income</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Interest Income">Interest Income</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Interest Expense">Interest Expense</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Non-interest Income and Noninterest Expense">
            Non-interest Income and Noninterest Expense
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Charge-offs and Recoveries on Loans/Leases, Cash Dividends and Number of Employees">
            Charge-offs and Recoveries on Loans/Leases, Cash Dividends and
            Number of Employees
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Assets">Assets</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Investment Securities">Investment Securities</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Loans and Leases">Loans and Leases</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#General Comments">General Comments</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Loans to Individuals">Loans to Individuals</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Liabilities and Equity Capital">
            Liabilities and Equity Capital
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Deposits">Deposits</a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Interest Earning Assets and Interest-Bearing Liabilities">
            Interest Earning Assets and Interest-Bearing Liabilities
          </a>
        </Typography>
        <Typography variant="body2" component="div">
          <a href="#Deposits in Foreign Offices and Past Due and Nonaccrual Loans & Leases">
            Deposits in Foreign Offices and Past Due and Nonaccrual Loans &
            Leases
          </a>
        </Typography>

        <Typography variant="h2" id="INTRODUCTION">
          INTRODUCTION
        </Typography>
        <Typography variant="body2">
          The Historical Statistics on Banking (HSOB) is intended to be a
          reference and source document for those interested in banking history
          and in performing analyses on major trends in banking. It contains
          both structure and financial data on insured commercial banks and
          savings institutions from the Federal Deposit Insurance Corporation's
          inception in 1934 to the present as well as bank failures and
          assistance transactions. Its primary goal is to provide comprehensive
          industry data about FDIC-insured depository institutions.
        </Typography>

        <Typography variant="body2">
          In addition to the HSOB, the FDIC offers other products that may
          provide more detail and analysis for current and historical data.
          These products include data for individual institutions, summary level
          data and peer group analysis. These products can be found under the
          Bank Data and Statistics or the Research and Analysis pages on the
          FDIC's web site, www.fdic.gov.
        </Typography>

        <Typography variant="body2">
          FDIC.gov {"->"} INDUSTRY ANALYSIS {"->"} Bank Data and Statistics
        </Typography>

        <Typography variant="body2">
          Call Reports and Thrift Financial Reports -
          http://www5.fdic.gov/Call_TFR_Rpts/index.asp
        </Typography>

        <Typography variant="body2">
          Central Data Repository - https://cdr.ffiec.gov/public/
        </Typography>

        <Typography variant="body2">
          Call Reports and Thrift Financial Reports from 2001 to the present for
          individual banks and savings associations are available for viewing
          and downloading.
        </Typography>

        <Typography variant="body2">
          Institution Directory -
          http://www5.fdic.gov/idasp/advSearchLanding.asp
        </Typography>

        <Typography variant="body2">
          The FDIC Institution Directory (ID) provides the latest comprehensive
          financial and demographic data for every FDIC-insured institution,
          including the most recent quarterly financial statements, with
          performance and condition ratios.
        </Typography>

        <Typography variant="body2">
          Statistics on Depository Institutions -
          http://www5.fdic.gov/sdi/main.asp
        </Typography>

        <Typography variant="body2">
          The FDIC Statistics on Depository Institutions (SDI) is an advanced
          feature of the Institution Directory (ID) that allows you to obtain
          more detailed financial reports. It also provides you with the ability
          to create reports containing customized peer groups of FDIC-insured
          institutions as well as summarize that data at the bank holding
          company level.
        </Typography>

        <Typography variant="body2">
          FDIC.gov {"->"} INDUSTRY ANALYSIS {"->"} Research and Analysis
        </Typography>

        <Typography variant="body2">
          FDIC Quarterly Banking Profile - http://www5.fdic.gov/qbp/index.asp┬á
        </Typography>

        <Typography variant="body2">
          The FDIC Quarterly Banking Profile (QBP) provides the most timely
          comprehensive summary of financial results for all FDIC-insured
          institutions on a quarterly basis. This report card on industry status
          and performance includes written analyses, graphs and statistical
          tables.
        </Typography>

        <Typography variant="body2">
          Statistics on Banking - http://www5.fdic.gov/SDI/SOB/
        </Typography>

        <Typography variant="body2">
          The Statistics on Banking is a quarterly publication that provides
          detailed aggregate financial information as well as key structural
          data (number of institutions and branches) for all FDIC- insured
          institutions.
        </Typography>

        <Typography variant="body2">
          For additional information regarding these publications, please refer
          to the individual web sites or the Bank Data Guide,
          http://www.fdic.gov/bank/statistical/guide/index.html.
        </Typography>

        <Typography variant="h2" id="CONTENTS">
          CONTENTS
        </Typography>

        <Typography variant="body2">
          Commercial Bank Reports and Savings Institution Reports are grouped
          into three categories:
        </Typography>

        <Typography variant="body2">
          Institution and Structure - numbers and types of institutions and
          branches as of year-end
        </Typography>

        <Typography variant="body2">
          Financial Data - Income Statement - year-to-date income and expense
          data
        </Typography>

        <Typography variant="body2">
          Financial Data - Balance Sheet - balance sheet data as of year-end
        </Typography>

        <Typography variant="body2">
          Data Availability - National Aggregates/State Aggregates
        </Typography>

        <Typography variant="body2">
          Commercial Banks 1934 - current 1966 - current
        </Typography>

        <Typography variant="body2">
          Savings Institutions 1984 - current 1984 ΓÇô current
        </Typography>

        <Typography variant="h2" id="DATA SOURCES">
          DATA SOURCES
        </Typography>

        <Typography variant="body2">
          The structure and financial data sources used in the preparation of
          the publication are:
        </Typography>

        <Typography variant="body2">
          Annual Reports of the Federal Deposit Insurance Corporation, 1934 -
          current
        </Typography>

        <Typography variant="body2">
          Assets and Liabilities, Commercial and Mutual Savings Banks, 1934 -
          1983
        </Typography>

        <Typography variant="body2">
          Bank Operating Statistics, 1968 - 1983
        </Typography>

        <Typography variant="body2">
          FDIC's Research Information System (RIS), 1984 - current
        </Typography>

        <Typography variant="body2">
          The primary sources of financial data for the publications listed
          above are the Reports of Income and Condition submitted by
          FDIC-insured institutions to the Federal commercial bank regulators
          and the Thrift Financial Reports submitted by the FDIC-insured savings
          institutions that were regulated by the Office of Thrift
          Supervision(1984-2011). Structure data are based on information
          contained in the FDIC financial institution structure data base
          (SIMS).
        </Typography>

        <Typography variant="h2" id="METHODOLOGY">
          METHODOLOGY
        </Typography>

        <Typography variant="body2">
          In order to provide the most recent and accurate data, all financial
          data at both the national and state levels from 1984 to the present
          have been obtained from the FDIC's Research Information System (RIS).
          The data in the data base reflects revisions and amendments made
          subsequent to publication in the hard copy sources. All other data has
          been obtained from the other four sources listed above. When using
          published data, both structure and financial values were obtained from
          the latest edition reflecting the data for a particular year. For
          example, the 1965 Annual Report was the source for much of the 1957
          data that appear in the publication. Since not all data, particularly
          at the state level, were revised and republished in later editions of
          the sources, multiple sources for the same year had to be used. The
          effect of using two sources occasionally results in differences in
          aggregate values for the data. These differences are not considered
          significant for the intended use and purpose of the publication
        </Typography>

        <Typography variant="h2" id="COMPARABILITY OF DATA">
          COMPARABILITY OF DATA
        </Typography>

        <Typography variant="body2">
          Reporting requirements and instructions have changed considerably over
          the period covered by this publication. Where possible,adjustments
          have been made to account for these differences to make the values
          adhere as closely as possible to current requirements and
          instructions. The notes accompanying the tables are an integral part
          of the publication and provide information on adjustments made to
          source data and on reporting differences over time.
        </Typography>

        <Typography variant="h2" id="LEVEL OF CONSOLIDATION">
          LEVEL OF CONSOLIDATION
        </Typography>

        <Typography variant="body2">
          All data from 1934 to 1973 represent a consolidation of all domestic
          operations of the institutions and, where available, operations in
          what is designated &quot;Other Areas&quot; in source publications.
          &quot;Other areas&quot; are represented by Guam, Puerto Rico, Virgin
          Islands, and all other U.S. Territories and possessions. With some
          exceptions, primarily at the state level, all financial data from 1974
          to the present represent the consolidation of domestic and foreign
          operations, including operations in &quot;other areas&quot;.
        </Typography>

        <Typography variant="h2" id="VALIDATION">
          VALIDATION
        </Typography>

        <Typography variant="body2">
          Every attempt has been made to assure the accuracy and integrity of
          the data contained in the publication. Any inconsistency brought to
          our attention will be investigated and corrected or explained in
          future editions.
        </Typography>

        <Typography variant="h2" id="EXCLUSIONS">
          EXCLUSIONS
        </Typography>

        <Typography variant="body2">
          Data on depository institutions not insured by the FDIC are not
          included in this publication. Institutions in the following categories
          are excluded, although such institutions may perform many of the same
          functions as FDIC-insured depository institutions:
        </Typography>

        <Typography variant="body2">
          State-chartered and private banks not insured by the FDIC
        </Typography>

        <Typography variant="body2">
          FDIC-Insured domestic branches of foreign banks (IBA offices)
        </Typography>

        <Typography variant="body2">Nondeposit trust companies</Typography>

        <Typography variant="body2">
          Other institutions not insured by the FDIC, including credit unions,
          building and loan associations, personal loan companies, industrial
          banks, loan and investment companies, and similar institutions,
          chartered under laws applicable to such institutions or under general
          incorporation laws regardless of whether such institutions are called
          'banks'
        </Typography>

        <Typography variant="body2">
          Institutions chartered under banking or trust company laws, but
          operating as investment or title insurance companies and not engaged
          in deposit taking
        </Typography>

        <Typography variant="body2">
          Federal Reserve Banks and other banks, such as the Federal Home Loan
          Banks, which operate as rediscount banks and do not accept deposits
          except from financial institutions
        </Typography>

        <Typography variant="body2">
          Branches of FDIC-insured OTS-regulated institutions
        </Typography>

        <Typography variant="h2" id="DEFINITIONS">
          DEFINITIONS
        </Typography>

        <Typography variant="body2">
          Please note that the terms listed below are a partial list of
          definitions that are available. Other definitions are available in the
          Help Index, Institution Directory (ID) and Statistics on Banking (SOB)
          systems.
        </Typography>

        <Typography variant="h3" id="FDIC-Insured Institutions">
          FDIC-Insured Institutions
        </Typography>

        <Typography variant="body2">
          The category of FDIC-insured commercial banks includes all commercial
          banks insured by the Federal Deposit Insurance Corporation (FDIC). It
          also includes all commercial banks insured by the FDIC that are
          regulated by and submit financial data to one of the three Federal
          commercial bank regulators (Board of Governors of the Federal Reserve
          System, Federal Deposit Insurance Corporation or Office of the
          Comptroller of the Currency). The category of FDIC-insured savings
          institutions includes all institutions insured by the FDIC that
          operated under state or federal banking codes applicable to thrift
          institutions. Data on savings institutions that have been placed in
          Resolution Trust Corporation conservatorship (1989 through 1995) are
          not aggregated with other savings institutions, since they do not
          operate as privately-held entities, and their resolution costs do not
          accrue to the FDIC. These RTC conservatorship institutions are listed
          separately as memoranda items where applicable.
        </Typography>

        <Typography variant="h3" id="Charter Class">
          Charter Class
        </Typography>

        <Typography variant="body2">
          The FDIC assigns classification codes indicating an institution's
          charter type (commercial bank, savings bank, or savings association),
          its chartering agent (state or federal government), its Federal
          Reserve membership status (member or nonmember), and its primary
          federal regulator (state-chartered institutions are subject to both
          federal and state supervision). These codes are:
        </Typography>

        <Typography variant="body2">
          N - National chartered commercial bank supervised by the Office of the
          Comptroller of the Currency
        </Typography>

        <Typography variant="body2">
          SM - State charter Fed member commercial bank supervised by the
          Federal Reserve
        </Typography>

        <Typography variant="body2">
          NM - State charter Fed nonmember commercial bank supervised by the
          FDIC
        </Typography>

        <Typography variant="body2">
          SA - State or federal charter savings association supervised by the
          Office of Thrift Supervision or Office of the Comptroller of the
          Currency
        </Typography>

        <Typography variant="body2">
          SB - State charter savings bank supervised by the FDIC
        </Typography>

        <Typography variant="h3" id="Charter Type">
          Charter Type
        </Typography>

        <Typography variant="body2">
          A charter is the legal authorization to conduct business and is
          granted to a financial institution by federal or state government.
          Charter types include:
        </Typography>

        <Typography variant="h3" id="All Charters">
          All Charters
        </Typography>

        <Typography variant="body2">
          Commercial banks, savings institutions and U.S. branches of foreign
          banks insured by the FDIC.
        </Typography>

        <Typography variant="h3" id="Insured Commercial Banks">
          Insured Commercial Banks
        </Typography>

        <Typography variant="body2">
          Commercial banks insured by the FDIC. These institutions are regulated
          by one of the three Federal commercial bank regulators (FDIC, Federal
          Reserve Board or Office of the Comptroller of the Currency). The
          institutions submit financial reports to the Federal Reserve (state
          member banks), the FDIC (state nonmember banks), or the Office of the
          Comptroller of the Currency (national banks).
        </Typography>

        <Typography variant="h3" id="Insured Savings Institutions">
          Insured Savings Institutions
        </Typography>

        <Typography variant="body2">
          Savings institutions insured by FDIC that operate under state or
          federal banking codes applicable to thrift institutions.
        </Typography>

        <Typography variant="h3" id="Insured Branches of Foreign Banks">
          Insured Branches of Foreign Banks
        </Typography>

        <Typography variant="body2">
          Branches of foreign banks (banks chartered and headquartered outside
          the U.S.) that are insured by the FDIC. These institutions are
          regulated by one of the three Federal commercial bank regulators and
          submit financial data to the Federal Reserve.
        </Typography>

        <Typography variant="h3" id="Effective Date">
          Effective Date
        </Typography>

        <Typography variant="body2">
          The date that the failed / assisted institution ceased to exist as a
          privately held going concern. For institutions that entered into
          government ownership, such as FDIC Bridge Banks and RTC
          conservatorships, this is the date that they entered into such
          ownership.┬á
        </Typography>

        <Typography variant="h3" id="FDIC-Insured Commercial Banks">
          FDIC-Insured Commercial Banks
        </Typography>

        <Typography variant="body2">
          Includes all commercial banks insured by the FDIC. These institutions
          are regulated by and submit financial data to one of three federal
          commercial bank regulators (the Federal Reserve Board, the FDIC, or
          the Office of the Comptroller of the Currency). FDIC-insured
          commercial banks include the following categories of depository
          institutions insured by the FDIC:
        </Typography>

        <Typography variant="h3" id="National banks">
          National banks
        </Typography>

        <Typography variant="body2">
          State-chartered banks and trust companies, except savings banks
        </Typography>

        <Typography variant="body2">
          Commercial banks, either nationally or state-chartered, insured by the
          FDIC
        </Typography>

        <Typography variant="body2">
          Other financial institutions which operate under general banking
          codes, or are specifically authorized by law to accept deposits and in
          practice do so or the obligations of which are regarded as deposits
          for deposit insurance
        </Typography>

        <Typography variant="h3" id="FDIC-Insured Savings Institutions">
          FDIC-Insured Savings Institutions
        </Typography>

        <Typography variant="body2">
          Includes all institutions insured by either the FDIC operating under
          state or federal banking codes applicable to savings institutions.
          Data on savings institutions that have been placed in RTC
          conservatorship are not aggregated with those that were not, since the
          former do not operate as privately-held entities, and their resolution
          costs do not accrue to the FDIC. These RTC conservatorships are listed
          separately as memoranda, where applicable.
        </Typography>

        <Typography variant="h3" id="">
          Cert
        </Typography>

        <Typography variant="body2">
          The certificate number assigned by the FDIC used to identify
          institutions and for the issuance of insurance certificates. By
          clicking on this number, you will link to the Institution Directory
          (ID) system which will provide the last demographic and financial data
          filed by the selected institution.
        </Typography>

        <Typography variant="h3" id="Failure/Assistance">
          Failure/Assistance
        </Typography>

        <Typography variant="body2">
          The given institution has failure stature or it can be assistance has
          been provided by FDIC in merging with other institution.
        </Typography>

        <Typography variant="h3" id="Estimated Loss">
          Estimated Loss
        </Typography>

        <Typography variant="body2">
          The estimated loss is the difference between the amount disbursed from
          the Deposit Insurance Fund (DIF) to cover obligations to insured
          depositors and the amount estimated to be ultimately recovered from
          the liquidation of the receivership estate. Estimated losses reflect
          unpaid principal amounts deemed unrecoverable and do not reflect
          interest that may be due on the DIF's administrative or subrogated
          claims should its principal be repaid in full.
        </Typography>

        <Typography variant="body2">Notes:</Typography>

        <Typography variant="body2">
          Comprehensive data on estimated losses are not available for
          FDIC-insured failures prior to 1986, or for FSLIC-insured failures
          from 1934-88. Estimated loss is presented as &quot;N/A&quot; in years
          for which comprehensive information is not available.
        </Typography>

        <Typography variant="body2">
          Estimated Loss data was previously referred to as 'Estimated Cost' in
          past releases of the Historical Statistic on Banking. For RTC
          receiverships, the 'Estimated Cost' included an allocation of FDIC
          corporate revenue and expense items such as interest expense on
          Federal Financing Bank debt, interest expense on escrowed funds and
          interest revenue on advances to receiverships. Other FDIC
          receiverships did not include such an allocation. To maintain
          consistency with FDIC receiverships, the RTC allocation is no longer
          reflected in the estimated loss amounts for failed / assisted
          institutions that were resolved through RTC receiverships.
        </Typography>

        <Typography variant="body2">
          Beginning with the release of 2007 information, the 'Estimated Loss'
          in the Historical Statistics on Banking is presented and defined
          consistently with the aggregate Estimated Receivership Loss for
          FRF-RTC institutions and Estimated Losses for FDIC receiverships that
          are reported in the FDIC's Annual Report. The estimated loss is
          obtained from the FDIC's Failed Bank Cost Analysis (FBCA) report and
          the RTC Loss report. The FBCA provides data for receiverships back to
          1986. The RTC Loss Report provides similar data back to 1989.
        </Typography>

        <Typography variant="body2">
          Questions regarding Estimated Loss should be sent to
          DOFBusinessCenter@fdic.gov.
        </Typography>

        <Typography variant="body2">
          Also, for more detail regarding resolution transactions and the FDIC's
          receivership activities, see Managing the Crisis: The FDIC and RTC
          Experience, a historical study prepared by the FDIC's Division of
          Resolutions and Receiverships. Copies are available from the FDIC's
          Public Information Center.
        </Typography>

        <Typography variant="h3" id="Insurance Fund">
          Insurance Fund
        </Typography>

        <Typography variant="body2">
          Before 1989, there were two federal deposit insurance funds, one
          administered by the FDIC, which insured deposits in commercial banks
          and state-chartered savings banks, and another administered by the
          Federal Savings and Loan Insurance Corporation (FSLIC), which insured
          deposits in state- and federally-chartered savings associations. In
          1989, the Financial Institutions Reform, Recovery and Enforcement Act
          (FIRREA) specified that thereafter the FDIC would be the federal
          deposit insurer of all banks and savings associations and would
          administer both the FDIC fund, which was renamed the Bank Insurance
          Fund (BIF) and the replacement for the insolvent FSLIC fund, which was
          called the Savings Association Insurance Fund (SAIF). Although it was
          created in 1989, the SAIF was not responsible for savings association
          failures until 1996. From 1989 through 1995, savings association
          failures were the responsibility of the Resolution Trust Corporation
          (RTC). In February 2006, The Federal Deposit Insurance Reform Act of
          2005 provided for the merger of the BIF and the SAIF into a single
          Deposit Insurance Fund (DIF). Necessary technical and conforming
          changes to the law were made under The Federal Deposit Insurance
          Reform Conforming Amendments Act of 2005. The merger of the funds was
          effective on March 31, 2006.
        </Typography>

        <Typography variant="body2">
          For additional information about deposit insurance fund and
          legislation, go to http://www.fdic.gov/deposit/insurance/index.html.
        </Typography>

        <Typography variant="h3" id="FIN">
          FIN
        </Typography>

        <Typography variant="body2">
          Financial Institution Number is a unique number assigned to the
          institution as an Assistance Agreement, Conservatorship, Bridge Bank
          or Receivership.
        </Typography>

        <Typography variant="h3" id="State">
          State
        </Typography>

        <Typography variant="body2">
          The state in which the headquarters of the institution are physically
          located. The FDIC Act defines state as any State of the United States,
          the District of Columbia, and any territory of the United States,
          Puerto Rico, Guam, American Samoa, the Trust Territory of the Pacific
          Islands, the Virgin Island, and the Northern Mariana Islands.
        </Typography>

        <Typography variant="body2">
          You can select one of the three summary levels or individual states,
          but not both. For the Bank Failures and Assistance Transaction report
          you can select multiple states by holding down the Control Key and
          selecting specific states.
        </Typography>

        <Typography variant="h3" id="Location">
          Location
        </Typography>

        <Typography variant="body2">
          The city and state (or territory) of the headquarters of the
          institution.
        </Typography>

        <Typography variant="h3" id="Institution Name">
          Institution Name
        </Typography>

        <Typography variant="body2">
          This is the legal name of the institution. When available, the
          Institution's name links to useful information for the customers and
          vendors of these institutions. This information includes press
          releases, information about the acquiring institution, (if
          applicable), how your accounts and loans are affected, and how vendors
          can file claims against the receivership.┬á
        </Typography>

        <Typography variant="h3" id="Total Assets">
          Total Assets
        </Typography>

        <Typography variant="body2">
          The Total assets owned by the institution including cash, loans,
          securities, bank premises and other assets as of the last Call Report
          or Thrift Financial Report filed by the institution prior to the
          effective date. Note this does not necessarily reflect total assets on
          the last report filed because in some cases reports were filed after
          the effective date. This total does not include off-balance-sheet
          accounts.
        </Typography>

        <Typography variant="h3" id="Total Deposits">
          Total Deposits
        </Typography>

        <Typography variant="body2">
          Total including demand deposits, money market deposits, other savings
          deposits, time deposits and deposits in foreign offices as of the last
          Call Report or Thrift Financial Report filed by the institution prior
          to the effective date. Note this does not necessarily reflect total
          deposits on the last report filed because in some cases reports were
          filed after the effective date.
        </Typography>

        <Typography variant="h3" id="Transaction Types">
          Transaction Types
        </Typography>

        <Typography variant="body2">
          Institutions have been resolved through several different types of
          transactions. The transaction types outlined below can be grouped into
          three general categories, based upon the method employed to protect
          insured depositors and how each transaction affects a failed /
          assisted institution's charter. In most assistance transactions,
          insured and uninsured depositors are protected, the failed / assisted
          institution remains open and its charter survives the resolution
          process. In purchase and assumption transactions, the failed /
          assisted institution's insured deposits are transferred to a successor
          institution, and its charter is closed. In most of these transactions,
          additional liabilities and assets are also transferred to the
          successor institution. In payoff transactions, the deposit insurer -
          the FDIC or the former Federal Savings and Loan Insurance Corporation
          - pays insured depositors, the failed / assisted institution's charter
          is closed, and there is no successor institution. For a more complete
          description of resolution transactions and the FDIC's receivership
          activities, see Managing the Crisis: The FDIC and RTC Experience, a
          study prepared by the FDIC's Division of Resolutions and
          Receiverships. Copies are available from the FDIC's Public Information
          Center.
        </Typography>

        <Typography variant="body2">
          Category 1 - Institution's charter survives
        </Typography>

        <Typography variant="body2">
          A/A - Assistance Transactions. These include:
        </Typography>

        <Typography variant="body2">Transactions</Typography>
        <Typography variant="body2">
          where assistance was provided to the acquirer, who purchased the
          entire institution. For a few FSLIC transactions, the acquirer
          purchased the entire bridge bank - type entity, but certain other
          assets were moved into a liquidating receivership prior to the sale.
        </Typography>

        <Typography variant="body2">Open bank</Typography>
        <Typography variant="body2">
          Assistance transactions, including those where assistance was provided
          under a systemic risk determination (in such cases any costs that
          exceed the amounts estimated under the least cost resolution
          requirement would be recovered through a special assessment on all
          FDIC-insured institutions).
        </Typography>

        <Typography variant="body2">
          REP - Re-privatization, management takeover with or without assistance
          at takeover, followed by a sale with or without additional assistance.
        </Typography>

        <Typography variant="body2">Category 2</Typography>

        <Typography variant="body2">
          Institution's charter is terminated, insured deposits plus some assets
          and other liabilities are transferred to a successor charter
        </Typography>

        <Typography variant="body2">
          P&amp;A - Purchase and Assumption, where some or all of the deposits,
          certain other liabilities and a portion of the assets (sometimes all
          of the assets) were sold to an acquirer. It was not determined if all
          of the deposits (PA) or only the insured deposits (PI) were assumed.
        </Typography>

        <Typography variant="body2">
          PA - Purchase and Assumption, where the insured and uninsured
          deposits, certain other liabilities and a portion of the assets were
          sold to an acquirer.
        </Typography>

        <Typography variant="body2">
          PI - Purchase and Assumption of the insured deposits only, where the
          traditional P&amp;A was modified so that only the insured deposits
          were assumed by the acquiring institution.
        </Typography>

        <Typography variant="body2">
          IDT - Insured Deposit Transfer, where the acquiring institution served
          as a paying agent for the insurer, established accounts on their books
          for depositors, and often acquired some assets as well. Includes ABT
          (asset-backed transfer, a FSLIC transaction that is very similar to an
          IDT).
        </Typography>

        <Typography variant="body2">
          MGR - An institution where FSLIC took over management and generally
          provided financial assistance. FSLIC closed down before the
          institution was sold.
        </Typography>

        <Typography variant="body2">Category 3</Typography>

        <Typography variant="body2">
          PO - Payout, where the insurer paid the depositors directly and placed
          the assets in a liquidating receivership.
        </Typography>

        <Typography variant="body2">
          Note: Includes transactions where the FDIC established a Deposit
          Insurance National Bank to facilitate the payout process.
        </Typography>

        <Typography variant="h2" id="">
          COMMENTS, SUGGESTIONS AND REQUESTS
        </Typography>

        <Typography variant="body2">
          Comments and content suggestions for the Historical Statistics on
          Banking should be sent to:
        </Typography>

        <Typography variant="body2">
          <a href="http://www5.fdic.gov/idasp/DIRSInfoRequest.asp">
            http://www5.fdic.gov/idasp/DIRSInfoRequest.asp
          </a>
        </Typography>

        <Typography variant="h2" id="">
          DATA AVAILABILITY
        </Typography>

        <Typography variant="body2">
          Historical Statistics on Banking (HSOB) provides annual statistical
          information on the banking industry beginning in 1934. These data can
          be used to identify and analyze long-term trends and to develop
          benchmarks to evaluate the current condition of the banking and thrift
          industries.
        </Typography>

        <Typography variant="body2">
          The HSOB contains aggregated data from individual financial reports
          filed by FDIC-insured commercial banks and savings institutions. These
          aggregated data are also available for individual states, U.S.
          territories and U.S. possessions. For the most current quarterly
          aggregate data, please refer to the Statistics on Depository
          Institutions (SDI).
        </Typography>

        <Typography variant="body2">
          FDIC provides financial and structural data about individual
          institutions in the Institution Directory (ID).
        </Typography>

        <Typography
          variant="h2"
          id="Number of Institutions, Branches and Total Offices"
        >
          Number of Institutions, Branches and Total Offices
        </Typography>

        <Typography variant="h3" id="Origin of the FDIC">
          Origin of the FDIC
        </Typography>

        <Typography variant="body2">
          On January 1, 1934 there were 15,034 licensed banks: 12,551 insured
          commercial banks; 1,904 uninsured commercial banks; 214 insured mutual
          savings banks; and 365 uninsured mutual savings banks. When the
          Temporary Federal Deposit Insurance Plan went into effect on January
          1, 1934, 12,551 commercial banks were admitted to the Temporary
          Federal Deposit Insurance Fund and 214 mutual savings banks were
          admitted to a separate Temporary Fund for Mutuals. The two funds
          combined into the Federal Deposit Insurance Fund on July 1, 1935.
        </Typography>

        <Typography variant="h3" id="Commercial Banks - Original Definitions">
          Commercial Banks - Original Definitions
        </Typography>

        <Typography variant="body2">
          The following definitions (as applied to the number of institutions in
          the table) are provided in the 1934 Annual Report:
        </Typography>

        <Typography variant="body2">
          Insured - insured by the Federal Deposit Insurance Corporation.
        </Typography>

        <Typography variant="body2">
          Uninsured (synonym - not insured) - not insured by the Federal Deposit
          Insurance Corporation. (An uninsured institution, however, could be
          insured by a state insurance fund, a private sector insurance company,
          or the Savings Bank Trust Company).
        </Typography>

        <Typography variant="body2">
          Commercial banks - includes the following groups of banks in the
          continental United States operating under licenses issued by the
          Secretary of the Treasury or by state banking authorities: national
          banks; state-chartered commercial banks; ┬á┬á┬á┬á┬á┬áloan and trust
          companies; stock savings banks; private banks under state supervision;
          and industrial banks.
        </Typography>

        <Typography variant="body2">
          Subsequent changes or revisions to this definition relate to both
          groups of institutions and to individual institutions.
        </Typography>

        <Typography
          variant="h3"
          id="Commercial Banks - Changes to the Definitions"
        >
          Commercial Banks - Changes to the Definitions
        </Typography>

        <Typography variant="body2">
          1934 - Two national banks in Alaska that are not members of the
          Federal Reserve System are included specifically.
        </Typography>

        <Typography variant="body2">
          1935 - Morris Plan Banks that become insured are included.
        </Typography>

        <Typography variant="body2">
          1936 - The definition of commercial banks is revised to read: all
          operating national banks; all incorporated state banks; all trust
          companies and banks and trust companies regularly engaged in the
          business of receiving deposits
        </Typography>

        <Typography variant="body2">
          (except mutual savings banks, and in New Hampshire, guaranty savings
          banks); all stock savings banks; banks in conservatorship or operating
          under restrictions; (provided they are authorized to and in fact do
          accept new deposits); ssuch industrial and Morris Plan banks as
          operate under general banking codes or operate under the same codes of
          law as insured industrial banks; branches of foreign banks which
          engage in a general deposit business; cash depositories; private banks
          under state supervision; insured trust companies, even though not
          engaged in regular deposit banking (nondeposit trust companies); the
          chief office in each of the US possessions of American banks engaged
          in a general deposit business in those possessions
        </Typography>

        <Typography variant="body2">
          1937 - 1946 - The last phrase of the 1936 definition of commercial
          banks is replaced by the following: American branches engaged in a
          general banking business in US possessions (where more than one branch
          is maintained by a given bank in any one possession, the chief or
          central office is classified (and counted) as a bank and the other
          offices are classified (and counted) as branches).
        </Typography>

        <Typography variant="body2">
          1947 - The definition of commercial banks is revised to include:
          national banks (except those not regularly engaged in deposit
          banking); incorporated state banks; trust companies; banks and trust
          companies regularly engaged in the business of receiving deposits,
          whether demand or time; (except mutual savings banks); stock savings
          banks, including guaranty savings banks in New Hampshire; industrial
          banks and Morris Plan banks which operate under general banking codes
          or are specifically authorized by law to accept deposits and in
          practice, do so, or the obligations of which are regarded as deposits
          for deposit insurance; special types of banks of deposit; cash
          depositories in South Carolina; cooperative exchanges in Arkansas;
          savings and loan companies operating under Superior Court charters in
          Georgia; government operated banks in American Samoa, Guam and North
          Dakota; a cooperative bank, usually classified as a credit union;
          operating under a special charter in New Hampshire; two savings
          institutions, known as &quot;trust companies&quot;, operating under a
          special charter in Texas; Savings Bank Trust Company in New York;
          branches of foreign banks which engage in a general deposit business
          in the continental United States or in the US possessions; in U. S.
          possessions, branches of American banks engaged in a general deposit
          business.
        </Typography>

        <Typography variant="body2">
          1948 - The 1947 definition is revised to add a government bank in
          Puerto Rico.
        </Typography>

        <Typography variant="body2">
          1949 - The 1947 definition is revised to include non-deposit trust
          companies with a national charter.
        </Typography>

        <Typography variant="body2">
          1950 - The government operated bank in Guam is dropped from the
          definition, it is no longer insured or no longer in operation.
        </Typography>

        <Typography variant="body2">
          1952 - A revision indicates that there are four branches of foreign
          banks (counted as banks) which engage in a general deposit business in
          the continental United States or in Puerto Rico.
        </Typography>

        <Typography variant="body2">
          1961 - The 1947 definition relating to the inclusion of cooperative
          exchanges in Arkansas is changed to the singular, indicating that
          there is only one insured cooperative exchange operating now. There
          are now eight branches of foreign banks included.
        </Typography>

        <Typography variant="body2">
          1962 - Nine branches of foreign banks are included.
        </Typography>

        <Typography variant="body2">
          1963 - The number of foreign branches operating in the United States,
          Puerto Rico and the Virgin Islands is 17.
        </Typography>

        <Typography variant="body2">
          1964 - Foreign branches are now operating in New York, Oregon,
          Washington, Puerto Rico and the Virgin Islands.
        </Typography>

        <Typography variant="body2">
          1966 - The one cooperative exchange in Arkansas is dropped.
        </Typography>

        <Typography variant="body2">
          1970 - The definition of Commercial banks is revised to include:
          national banks; incorporated state chartered banks; trust companies;
          bank and trust companies regularly engaged in the business of
          receiving deposits, whether demand or time; (except mutual savings
          banks) stock savings banks, including guaranty savings banks in New
          Hampshire; industrial and Morris Plan banks which operate under
          general banking codes, or are specifically authorized by law to accept
          deposits and in practice, do so, or the obligations of which are
          regarded as deposits for deposit insurance; special types of banks of
          deposit regulated certificated banks and a savings and loan company
          operating under a Superior Court charter in Georgia; government
          operated banks in North Dakota and Puerto Rico; a cooperative bank,
          usually classified as a credit union, operating under a special
          charter in New Hampshire; a savings institution, known as a
          &quot;trust company&quot;, operating under a special charter in Texas;
          the Savings Bank Trust Company in New York; branches of foreign banks
          in Illinois, Massachusetts, New York, Oregon, Washington, Puerto Rico
          and the Virgin Islands.
        </Typography>

        <Typography variant="body2">
          1975 - Special types of banks of deposit and the savings and loan
          operating under a Superior Court charter in Georgia are no longer
          included and the Savings Bank and Trust Company Northwest in
          Washington is added.
        </Typography>

        <Typography variant="body2">
          1976 - The cooperative bank operating under a special charter in New
          Hampshire is no longer included.
        </Typography>

        <Typography variant="body2">
          1977 - Guam is added to the list of states and U.S. Territories and
          Possessions with branches of foreign banks.
        </Typography>

        <Typography variant="body2">
          1978 - Pennsylvania is added as having a branch of a foreign bank.
        </Typography>

        <Typography variant="body2">
          1982 - The definition of Commercial banks is revised to include:
          national banks; incorporated state chartered banks and trust
          companies; bank and trust companies regularly engaged in the business
          of receiving deposits, whether demand or time; (except mutual savings
          banks) stock savings banks, including guaranty savings banks in New
          Hampshire; industrial and Morris Plan banks which operate under
          general banking codes, or are specifically authorized by law to accept
          deposits and in practice, do so, or the obligations of which are
          regarded as deposits for deposit insurance.
        </Typography>

        <Typography variant="body2">
          1984 - The definition of Commercial banks is revised to include:
          national banks; FDIC-insured state-chartered banks and trust
          companies, except savings banks; FDIC-insured industrial and Morris
          Plan banks which operate under general banking codes, or are
          specifically authorized by law to accept deposits and in practice, do
          so, or the obligations of which are regarded as deposits for deposit
          insurance.
        </Typography>

        <Typography variant="body2">
          1989 - The FIRREA enables SAIF insured thrift institutions to change
          their charter to become commercial banks.
        </Typography>

        <Typography variant="body2">
          1990-1991 - The definition of Commercial banks is revised to include:
          national banks; state-chartered banks and trust companies, except
          savings banks; industrial and Morris Plan banks which operate under
          general banking codes, or are specifically authorized by law to accept
          deposits and in practice, do so, or the obligations of which are
          regarded as deposits for deposit insurance; commercial banks, either
          national or state chartered; and insured by the FDIC Savings
          Association Insurance Fund (SAIF).
        </Typography>

        <Typography variant="body2">
          1992-Current - The definition of FDIC-insured Commercial banks and
          trust companies is revised to include: national banks; state chartered
          banks and trust companies, except savings banks, commercial banks,
          either national or state chartered; insured by the FDIC Bank Insurance
          Fund (BIF) or the FDIC Savings Association Insurance Fund (SAIF); or
          other financial institutions which operate under general banking
          codes, or are specifically authorized by law to accept deposits and in
          practice, do so, or the obligations of which are regarded as deposits
          for deposit insurance.
        </Typography>

        <Typography
          variant="h3"
          id="Offices and Branches - Changes to the Definitions"
        >
          Offices and Branches - Changes to the Definitions
        </Typography>

        <Typography variant="body2">
          1936 - Branches or additional offices include all offices of banks
          operating more than one office, other than head offices, at which
          deposits are received or checks cashed, and all offices of insured
          trust companies not engaged in deposit banking. The term
          &quot;branch&quot; includes any branch bank, branch office, branch
          agency, additional office or any branch or place of business located
          in any state of the United States or in Alaska, Hawaii, Puerto Rico,
          or the Virgin Islands at which deposits are received or checks paid or
          money lent.
        </Typography>

        <Typography variant="body2">
          1940 - Unit banks include all banks operating only one office at which
          deposits are received or checks cashed.
        </Typography>

        <Typography variant="body2">
          1942 - The reconcilement of office openings and closings indicates
          that total offices include facilities operated as agencies of the
          government. Such facilities are established in or near military
          installations at the request of the Secretary of the Treasury or of
          the commanding officer of the installation.
        </Typography>

        <Typography variant="body2">
          1950 - A footnote indicates that 6 offices in the possessions,
          formerly tabulated as banks, are now being counted as offices. The
          footnote is carried until the 1979 Annual Report.
        </Typography>

        <Typography variant="body2">
          1961 - Branches include all offices of a bank, other than its head
          office, at which deposits are received, checks paid or money lent.
          Banking facilities separate from a banking house, banking facilities
          at government installations, offices, agencies, paying or receiving
          stations, drive-in facilities and other facilities operated for
          limited purposes are defined as branches under the FDI Act, regardless
          of the fact that in certain states, including several which prohibit
          the operation of branches, such limited facilities are not considered
          branches within the meaning of state law.
        </Typography>

        <Typography variant="body2">
          1962 - A footnote indicates that total office counts include &quot;a
          few&quot; seasonal offices that may not be open for business as of
          December 31 of each year. The footnote is carried until the 1979
          Annual Report.
        </Typography>

        <Typography variant="body2">
          1980 - A footnote indicates that both insured and noninsured domestic
          branches of foreign banks are excluded from the total of insured
          commercial bank offices and are reflected as offices of noninsured
          banks of deposit.
        </Typography>

        <Typography variant="body2">
          1982 - A footnote indicates that 31 FDIC insured and 199 noninsured
          domestic branches of foreign banks (IBA reporters) are excluded from
          the total of insured commercial bank offices and are reflected as
          offices of noninsured banks of deposit. The number of such offices is
          not indicated in the footnotes of subsequent sources. A total of 2,523
          remote service facilities (EFTU's) were deleted from the count of
          insured commercial bank branches and total offices as of year-end.
          There is no indication of how many there were as of year end in
          previous years.
        </Typography>

        <Typography variant="body2">
          1988 - Source totals have been reduced by 366 contractual offices in
          Michigan. Contractual offices are established among affiliated banks
          and allow the offices of related banks to act as offices for the other
          related banks.
        </Typography>

        <Typography variant="body2">
          1989 - Source totals have been reduced by 444 contractual branches in
          Michigan.
        </Typography>

        <Typography variant="body2">
          1994 - Branch count changes affecting several years have been made.
          The adjustments are due to the continuous flow of data from banks to
          the Federal banking agencies concerning the status of offices. Other
          changes are due to retroactive corrections and adjustments affecting
          the structure database, the source of this data. Changes to counts
          prior to 1984 are due to the use of the structure database for all
          numbers rather than the use of previously published number in FDIC
          Annual Reports and Statistics on Banking.
        </Typography>

        <Typography variant="body2">
          1994 - Current - Offices include the following types: Multiple service
          offices; Military facilities; Drive-in facilities; Loan production
          offices; Consumer credit offices; Seasonal offices; Administrative
          offices; Messenger service offices; Supermarket banking offices; and
          Other offices.
        </Typography>

        <Typography variant="body2">
          Total Commercial Banks - represents the number of commercial banks
          filing a 12/31 financial report.
        </Typography>

        <Typography variant="body2">
          {" "}
          Branches - include all offices of a bank, other than its head office,
          at which deposits are received, checks paid or money lent. Banking
          facilities separate from a banking house, banking facilities at
          government installations, offices, agencies, paying or receiving
          stations, drive-in facilities and other facilities operated for
          limited purposes are defined as branches under the FDI Act (see Notes
          to User).{" "}
        </Typography>
        <Typography variant="body2">
          Offices - includes Multiple service offices, Military facilities,
          Drive-in facilities, Loan production offices, Consumer credit offices,
          Seasonal offices, Administrative offices, Messenger service offices,
          Supermarket banking offices, and Other offices.{" "}
        </Typography>

        <Typography variant="h2" id="Changes in Number of Institutions">
          Changes in Number of Institutions
        </Typography>

        <Typography variant="body2">Additions</Typography>

        <Typography variant="body2">
          New Charters - Represents institutions newly licensed or chartered by
          the Office of the Comptroller of the Currency (national banks) or by
          state banking authorities, including banking authorities in the U. S.
          territories or possessions. Includes de novo institutions as well as
          charters issued to take over a failing institution.
        </Typography>

        <Typography variant="body2">
          Conversions - Represents conversions of existing institutions of any
          type that meet the definition of commercial banks and have applied for
          and received FDIC insurance. Also includes bank relocations from one
          state to another.
        </Typography>

        <Typography variant="body2">Deletions</Typography>

        <Typography variant="body2">
          Unassisted Mergers - Represents voluntary mergers, consolidations or
          absorptions of two or more institutions.
        </Typography>

        <Typography variant="body2">
          Failures - Mergers - Represents mergers, consolidations or absorptions
          entered into as a result of supervisory actions. The transaction may
          or may not have required FDIC assistance.
        </Typography>

        <Typography variant="body2">
          Failures - Paid off - Represents institutions that were declared
          insolvent, the insured deposits of which were paid by the FDIC.
        </Typography>

        <Typography variant="body2">
          Other - Represents withdrawals from FDIC insurance, voluntary
          liquidations, or conversions to institutions that are not considered
          commercial banks. Also includes relocation of banks from one state to
          another.
        </Typography>

        <Typography variant="body2">Significant Events</Typography>

        <Typography variant="body2">1934</Typography>

        <Typography variant="body2">
          Conversions - 740 admissions to insurance
        </Typography>

        <Typography variant="body2">
          Failures-Mergers - 23 voluntary withdrawals from insurance
        </Typography>

        <Typography variant="body2">1935</Typography>

        <Typography variant="body2">
          Conversions: 71 reorganizations of or successions to restricted banks;
          19 reopenings of closed banks in liquidation or receivership; 104
          noninsured banks becoming insured; 3 banks added to prior year's
          ending balance;
        </Typography>

        <Typography variant="body2">
          Others: 51 other liquidations; 26 voluntary withdrawal from insurance;
          8 insured banks becoming noninsured; unaccounted for difference
        </Typography>

        <Typography variant="body2">1936</Typography>

        <Typography variant="body2">
          Conversions: 4 closed banks reopened; 47 noninsured banks becoming
          insured; 1 adjustment to prior year's ending balance
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 22 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">
          Others: 31 other liquidations; and 4 voluntary withdrawals from
          insurance
        </Typography>

        <Typography variant="body2">1937</Typography>

        <Typography variant="body2">
          Conversions: 36 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 20 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">
          Others: 36 other liquidations; 2 voluntary withdrawals from insurance
        </Typography>

        <Typography variant="body2">1938</Typography>

        <Typography variant="body2">
          Conversions: 25 noninsured banks becoming insured; and 1 closed bank
          reopened
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 22 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">
          Others: 36 other liquidations; 1 termination of insurance; 3 voluntary
          withdrawals from insurance; and 2 insured banks becoming noninsured
        </Typography>

        <Typography variant="body2">1939</Typography>

        <Typography variant="body2">
          Conversions: 18 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 20 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">Others: 25 other liquidations</Typography>

        <Typography variant="body2">1940</Typography>

        <Typography variant="body2">
          Conversions: 1 reopening of suspended bank; and 19 noninsured banks
          becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 20 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">Others: 33 other liquidations</Typography>

        <Typography variant="body2">1941</Typography>

        <Typography variant="body2">
          Conversions: 33 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 6 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">
          Others: 24 other liquidations; 1 voluntary withdrawal from insurance
        </Typography>

        <Typography variant="body2">1942</Typography>

        <Typography variant="body2">
          Conversions: 21 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 13 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">
          Others: 36 other liquidations; and 1 insured bank becoming noninsured
        </Typography>

        <Typography variant="body2">1943</Typography>

        <Typography variant="body2">
          Conversions: 16 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 1 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">
          Others: 43 other liquidations; and 1 insured bank becoming noninsured
        </Typography>

        <Typography variant="body2">1944</Typography>

        <Typography variant="body2">
          Conversions: 35 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 1 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">
          Others: 27 other liquidations; and 2 insured banks becoming noninsured
        </Typography>

        <Typography variant="body2">1945</Typography>

        <Typography variant="body2">
          Conversions: 21 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Others: 15 other liquidations; 1 insured bank becoming noninsured
        </Typography>

        <Typography variant="body2">1946</Typography>

        <Typography variant="body2">
          Conversions: 31 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 1 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">
          Others: 12 other liquidations; and 3 insured banks becoming noninsured
        </Typography>

        <Typography variant="body2">1947</Typography>

        <Typography variant="body2">
          Conversions: 29 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 3 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">
          Others: 6 other liquidations; and 1 insured banks becoming noninsured
        </Typography>

        <Typography variant="body2">1948</Typography>

        <Typography variant="body2">
          Conversions: 34 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 2 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">Others: 8 other liquidations</Typography>

        <Typography variant="body2">1949</Typography>

        <Typography variant="body2">
          Conversions: 41 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 4 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">
          Others: 4 other liquidations; and 1 withdrawal from insurance
        </Typography>

        <Typography variant="body2">1950</Typography>

        <Typography variant="body2">
          Conversions: 47 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 4 with financial aid of the FDI
        </Typography>

        <Typography variant="body2">Others: 7 other liquidations</Typography>

        <Typography variant="body2">1951</Typography>

        <Typography variant="body2">
          Conversions: 34 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 2 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">Others: 4 other liquidations</Typography>

        <Typography variant="body2">1952</Typography>

        <Typography variant="body2">
          Conversions: 26 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 1 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">
          Others: 7 other liquidations, 1 termination of insurance
        </Typography>

        <Typography variant="body2">1953</Typography>

        <Typography variant="body2">
          Conversions: 46 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 1 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">Others: 3 other liquidations</Typography>

        <Typography variant="body2">1954</Typography>

        <Typography variant="body2">
          Conversions: 32 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 2 with aid of the FDIC
        </Typography>

        <Typography variant="body2">
          Others: 2 other liquidations; and 2 insured banks becoming noninsured
        </Typography>

        <Typography variant="body2">1955</Typography>

        <Typography variant="body2">
          Conversions: 41 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 1 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">Others: 4 other liquidations</Typography>

        <Typography variant="body2">1956</Typography>

        <Typography variant="body2">
          Conversions: 64 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">Others : 6 other liquidations</Typography>

        <Typography variant="body2">1957</Typography>

        <Typography variant="body2">
          Conversions: 22 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">1958</Typography>

        <Typography variant="body2">
          Conversions: 29 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Failures-Mergers: 1 with financial aid of the FDIC
        </Typography>

        <Typography variant="body2">Others: 3 other liquidations</Typography>

        <Typography variant="body2">1959</Typography>

        <Typography variant="body2">
          Conversions: 54 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Others: 1 suspended insured bank becoming noninsured
        </Typography>

        <Typography variant="body2">1960</Typography>

        <Typography variant="body2">
          Conversions: 27 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">1961</Typography>

        <Typography variant="body2">
          Conversions: 31 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">1962</Typography>

        <Typography variant="body2">
          Conversions: 19 noninsured banks becoming insured; and 1 suspended
          bank reopened
        </Typography>

        <Typography variant="body2">Other: 1 other liquidation</Typography>

        <Typography variant="body2">1963</Typography>

        <Typography variant="body2">
          Conversions: 39 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">Others: 1 other liquidation</Typography>

        <Typography variant="body2">1964</Typography>

        <Typography variant="body2">
          Conversions: 20 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">Others: 1 other liquidation</Typography>

        <Typography variant="body2">1965</Typography>

        <Typography variant="body2">
          Conversions: 17 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">Others: 3 other liquidations</Typography>

        <Typography variant="body2">1966</Typography>

        <Typography variant="body2">
          Conversions: 24 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">Others: 1 other liquidation</Typography>

        <Typography variant="body2">1967</Typography>

        <Typography variant="body2">
          Conversions: 21 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">Others: 4 other liquidations</Typography>

        <Typography variant="body2">1968</Typography>

        <Typography variant="body2">
          Conversions: 19 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">1969</Typography>

        <Typography variant="body2">
          Conversions: 18 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">1970</Typography>

        <Typography variant="body2">
          Conversions: 13 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">Others: 1 other liquidation</Typography>

        <Typography variant="body2">1971</Typography>

        <Typography variant="body2">
          Conversions: 6 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">1972</Typography>

        <Typography variant="body2">
          Conversions: 4 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">1973</Typography>

        <Typography variant="body2">
          Conversions: 11 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">1974</Typography>

        <Typography variant="body2">
          Conversions: 6 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">1975</Typography>

        <Typography variant="body2">
          Conversions: 5 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">1976</Typography>

        <Typography variant="body2">
          Conversions: 6 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">1977</Typography>

        <Typography variant="body2">
          Conversions: 3 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Others: 1 discontinued deposit operation
        </Typography>

        <Typography variant="body2">1978</Typography>

        <Typography variant="body2">
          Conversions: 2 noninsured banks becoming insured&lt;
        </Typography>

        <Typography variant="body2">1979</Typography>

        <Typography variant="body2">
          Conversions: 3 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">1980</Typography>

        <Typography variant="body2">
          Conversions: 1 noninsured bank becoming insured
        </Typography>

        <Typography variant="body2">1981</Typography>

        <Typography variant="body2">
          Others: 1 insured bank becoming noninsured
        </Typography>

        <Typography variant="body2">1982</Typography>

        <Typography variant="body2">
          Conversions: 6 noninsured banks becoming insured; and 2 savings banks
          converting to commercial charter
        </Typography>

        <Typography variant="body2">1983</Typography>

        <Typography variant="body2">
          Conversions: 19 noninsured banks becoming insured; 2 savings banks
          converting to commercial charter; 1 bank added to count
        </Typography>

        <Typography variant="body2">
          Others: 6 discontinued deposit operation
        </Typography>

        <Typography variant="body2">1984</Typography>

        <Typography variant="body2">
          Conversions: 47 noninsured banks becoming insured; and 2 saving banks
          converting to commercial charter.
        </Typography>

        <Typography variant="body2">
          Others: 2 discontinued deposit operation; and 3 banks deleted from
          count
        </Typography>

        <Typography variant="body2">1985</Typography>

        <Typography variant="body2">
          Conversions: 41 noninsured banks becoming insured; 1 savings bank
          converting to commercial charter; 3 banks added to count
        </Typography>

        <Typography variant="body2">
          Others: 3 banks deleted from count
        </Typography>

        <Typography variant="body2">1986</Typography>

        <Typography variant="body2">
          Conversions: 31 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Others: 10 commercial banks converted to FSLIC; 2 discontinued deposit
          operation; 1 commercial bank converting to savings bank
        </Typography>

        <Typography variant="body2">1987</Typography>

        <Typography variant="body2">
          Conversions: 35 noninsured banks becoming insured; and 2 savings banks
          converting to commercial charter
        </Typography>

        <Typography variant="body2">
          Others: 1 commercial bank converting to FSLIC; 7 discontinued deposit
          operation; 3 commercial banks converting to savings banks; and 3 banks
          deleted from count
        </Typography>

        <Typography variant="body2">1988</Typography>

        <Typography variant="body2">
          Conversions: 3 noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Others: 2 commercial banks converting to FSLIC; 3 discontinued deposit
          operation; 4 insured banks becoming noninsured; and 2 commercial banks
          converted to savings banks
        </Typography>

        <Typography variant="body2">1989</Typography>

        <Typography variant="body2">
          Conversions: 6 noninsured banks becoming insured; 1 savings bank
          converting to commercial charter; and 2 added to count
        </Typography>

        <Typography variant="body2">
          Others: 1 commercial bank converting to FSLIC; 3 discontinued deposit
          operation; 1 insured bank becoming noninsured; and 1 deleted from
          count
        </Typography>

        <Typography variant="body2">1990</Typography>

        <Typography variant="body2">
          Conversions: 19 thrifts converting to commercial banks; and 5
          noninsured banks becoming insured
        </Typography>

        <Typography variant="body2">
          Others: 3 discontinued deposit operation; 2 withdrawals from FDIC
          insurance; and 1 insured banks becoming noninsured
        </Typography>

        <Typography variant="body2">1991</Typography>

        <Typography variant="body2">
          Conversions: 7 noninsured banks becoming insured; 28 savings bank and
          savings &amp; loans conversions
        </Typography>

        <Typography variant="body2">
          Others: 7 discontinued deposit operations; and 2 commercial bank
          converted to thrift charter
        </Typography>

        <Typography variant="body2">1992</Typography>

        <Typography variant="body2">
          New Charters: 30 new banks - de novo; 41 new charters established to
          absorb failing institutions; and 1 SAIF insured commercial bank
        </Typography>

        <Typography variant="body2">
          Conversions: 1 noninsured banks becoming insured; and 10 savings bank
          and thrift charter conversions
        </Typography>

        <Typography variant="body2">
          Others: 9 discontinued deposit operations; ┬á 8 withdrawals from FDIC
          insurance; and 1 commercial bank converted to thrift charter
        </Typography>

        <Typography variant="body2">1993</Typography>

        <Typography variant="body2">
          New Charters: 30 new charters; and 29 new charters established to
          absorb failing institutions
        </Typography>

        <Typography variant="body2">
          Conversions: 12 savings bank and thrift charter conversions
        </Typography>

        <Typography variant="body2">
          Others: 1 commercial bank converted to thrift charter; 24 withdrawals
          from FDIC insurance; and 11 other liquidations and closings
        </Typography>

        <Typography variant="body2">1994</Typography>

        <Typography variant="body2">
          New Charters: 49 new charters; and 1 new charter established to absorb
          a failing institution
        </Typography>

        <Typography variant="body2">
          Conversions: 11 savings bank and thrift charter conversions to
          commercial bank; and 6 relocations
        </Typography>

        <Typography variant="body2">
          Others: 5 withdrawals from FDIC insurance; and 2 commercial banks
          converting to thrift charter; 6 relocations; and 2 other liquidation
          or closing
        </Typography>

        <Typography variant="body2">1995</Typography>

        <Typography variant="body2">
          Conversions: 15 savings bank and thrift charter conversions to
          commercial bank; and 21 relocations
        </Typography>

        <Typography variant="body2">
          Others: 5 withdrawals from FDIC insurance; 4 commercial banks
          converting to thrift charter; and 21 relocations; and 2 other
          liquidation or closing
        </Typography>

        <Typography variant="body2">1996</Typography>

        <Typography variant="body2">
          Conversions: 10 thrift charter conversions; 2 admissions to insured
          status; 34 relocations
        </Typography>

        <Typography variant="body2">
          Others: 4 conversions to thrift charter; 6 withdrawals from FDIC
          insurance; 1 other liquidation or closing; 34 relocations
        </Typography>

        <Typography variant="body2">1997</Typography>

        <Typography variant="body2">
          Conversions: 10 thrift charter conversions; 2 admissions to insured
          status; and 34 relocations
        </Typography>

        <Typography variant="body2">
          Others: 4 conversions to thrift charter; 6 withdrawals from FDIC
          insurance; 1 other liquidation or closing; and 34 relocations
        </Typography>

        <Typography variant="body2">1998</Typography>

        <Typography variant="body2">
          Conversions: 14 thrift charter conversions; 3 admissions to insured
          status; 7 relocations
        </Typography>

        <Typography variant="body2">
          Others: 9 conversions to thrift charter; 4 withdrawals from FDIC
          insurance; and 7 relocations
        </Typography>

        <Typography variant="body2">1999</Typography>

        <Typography variant="body2">
          Conversions: 17 thrift charter conversions; and 3 relocations
        </Typography>

        <Typography variant="body2">
          Others: 8 conversions to thrift charter; 6 withdrawals from FDIC
          insurance; and 3 relocations
        </Typography>

        <Typography variant="body2">2000</Typography>

        <Typography variant="body2">
          Conversions: 11 thrift charter conversions; 3 admissions to insured
          status; and 9 relocations
        </Typography>

        <Typography variant="body2">
          Others: 4 conversions to thrift charter; 5 withdrawals from FDIC
          insurance; and 9 relocations
        </Typography>

        <Typography variant="body2">2001</Typography>

        <Typography variant="body2">
          Conversions: 11 thrift charter conversions; and 3 relocations; and 3
          other
        </Typography>

        <Typography variant="body2">
          Others: 4 conversions to thrift charter; 6 withdrawals from FDIC
          insurance; 3 relocations; and 5 liquidations
        </Typography>

        <Typography
          variant="h2"
          id="Number of Unit Institutions and Institutions with
Branches"
        >
          Number of Unit Institutions and Institutions with Branches
        </Typography>

        <Typography variant="body2">
          Unit banks are institutions that are operating only one office at
          which deposits are received or other banking business is conducted.
          Banks with branches are institutions that are operating one or more
          offices in addition to the main or head office.
        </Typography>

        <Typography variant="body2">
          Branches include all offices of a bank other than its head office, at
          which deposits are received, checks paid or money lent. Banking
          facilities separate from a banking house, banking facilities at
          government installations, offices, agencies, paying or receiving
          stations, drive-in facilities and other facilities operated for
          limited purposes are defined as branches under the FDI Act, regardless
          of the fact that in certain states, including several of which
          prohibit the operation of branches, such limited facilities are not
          considered branches within the meaning of state law.
        </Typography>

        <Typography variant="h2" id="Net Income">
          Net Income
        </Typography>

        <Typography variant="body2">General Comments</Typography>

        <Typography variant="body2">
          0 represents a positive amount less than $500
        </Typography>

        <Typography variant="body2">
          (0) represents a negative amount less than ($500)
        </Typography>

        <Typography variant="body2">NA -Not available</Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. Significant adjustments, changes or definitional differences
          from current requirements are identified or described. Comments
          describing changes in reporting practices relating to assets,
          liabilities and capital items are important in interpreting related
          income and expense items.
        </Typography>

        <Typography variant="body2">Significant Events</Typography>

        <Typography variant="body2">
          1947 - On December 8, 1947 the Internal Revenue Service adopted the
          reserve method for accounting for bad debt losses on loans.
        </Typography>

        <Typography variant="body2">
          1969 - Banks with total assets of $50 million or more are required to
          report income and expenses on an accrual basis. Consolidation is
          required for all majority owned bank premises subsidiaries and other
          majority owned subsidiaries meeting level of significance tests.
          Actual net loan losses (charge-offs less recoveries) were added to the
          Report of Income as an operating expense.
        </Typography>

        <Typography variant="body2">
          1972 - Banks with total assets of $25 million or more are required to
          prepare their reports based on accrual accounting. All banks are
          required to report income taxes on a current accrual basis.
        </Typography>

        <Typography variant="body2">
          1979 - The provision for possible loan losses based on management
          discretion replaces actual net loan losses.
        </Typography>

        <Typography variant="body2">
          1984 - All banks with $10 million or more in total consolidated assets
          are required to report income and expenses on an accrual basis.
        </Typography>

        <Typography variant="body2">
          A major reporting revision took place that initiated four reporting
          form sets: (1)FFIEC 031 filed by all banks that have one or more
          foreign offices, including International Banking Facilities (IBF), (2)
          FFIEC 032 filed by all banks with $300 million or more in total assets
          (3) FFIEC 033 filed by all banks with more than $100 million but less
          than $300 million in total assets, and (4) FFIEC 034 filed by all
          banks with less than $100 million in total assets.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">
          Number of Banks at Year End - Represents the total number of insured
          commercial banks at each year end. It includes Institutions that did
          not file a 12/31 financial report and other adjustments.
        </Typography>

        <Typography variant="body2">
          Total Interest Income - Represents total interest income earned or
          accrued on all assets.
        </Typography>

        <Typography variant="body2">
          Total Interest Expense - Represents total interest paid or accrued on
          all interest bearing liabilities.
        </Typography>

        <Typography variant="body2">
          Net Interest Income - Represents the difference between Total Interest
          Income and Total Interest Expense.
        </Typography>

        <Typography variant="body2">
          Total Noninterest Income - Represents the total of all noninterest
          income.
        </Typography>

        <Typography variant="body2">
          Total Noninterest Expense - Represents the total of all noninterest
          expenses.
        </Typography>

        <Typography variant="body2">
          Provision for Loan and Lease Losses
        </Typography>

        <Typography variant="body2">
          - 1984-present - Represents the amount needed to make the allowance
          for loan and lease losses adequate to absorb expected loan and lease
          losses, based upon management's evaluation of the bank's current loan
          and lease portfolio. The amount taken here may differ from the bad
          debt expense deduction taken for federal income tax purposes. Also
          included is the provision for allocated transfer risk reserve for
          those banks required to establish and maintain such a reserve.
        </Typography>

        <Typography variant="body2">
          - 1979-1983 - Represents the amount needed to make the allowance for
          loan losses adequate to absorb expected loan and lease losses, based
          upon management's evaluation of the bank's current loan and lease
          portfolio. The amount taken here may differ from the bad debt expense
          deduction taken for federal income tax purposes. For the first time,
          the acknowledgement of the difference between the amount expensed for
          financial reporting purposes and the amount deducted for income tax
          purposes was recognized by the booking of deferred taxes relating to
          this difference.
        </Typography>

        <Typography variant="body2">
          - 1969-1978 - Represents an addition to the allowance for possible
          loan losses based upon actual loan losses or the adoption of an
          historical average method.
        </Typography>

        <Typography variant="body2">
          - 1948-1968 - The amount reflects the net value of recoveries credited
          to reserves on loans less losses charged to reserves on loans.
        </Typography>

        <Typography variant="body2">
          - 1947 - On December 8, 1947 the Commissioner of Internal Revenue
          issued ruling Number 6209, &quot;Reserve Method of Accounting for Bad
          Debts in the Case of Banks.&quot; Under this ruling, banks are
          permitted to accumulate limited amounts of tax-free reserves for bad
          debt losses on loans.
        </Typography>

        <Typography variant="body2">
          - 1934-1946 - The amount reflects the net value of &quot;profits and
          recoveries on loans and reductions to valuation allowances&quot; less
          &quot;losses, charge-offs and additions to valuation allowances on
          loans.&quot; Details of the components are not available.
        </Typography>

        <Typography variant="body2">
          Pre-tax Net Operating Income - Represents Net Interest Income plus
          Total Noninterest Income less Total Noninterest Expense less the
          Provision for Loan and Lease Losses.
        </Typography>

        <Typography variant="body2">Securities Gains (Losses)</Typography>

        <Typography variant="body2">
          - 1959-present - Represents the net value of profits on securities
          sold or redeemed less losses on securities sold. Actual recoveries and
          actual charge-offs are reported separately and are included in
          Noninterest Income - All Other or Noninterest Expense - All Other,
          respectively.
        </Typography>

        <Typography variant="body2">
          - 1941-1958 - Represents the net value of recoveries on securities
          less losses and charge-offs on securities.
        </Typography>

        <Typography variant="body2">
          - 1934-1940 - Represents the net value of profits on securities sold
          or exchanged less losses, charge-offs and additions to valuation
          allowances on securities.
        </Typography>

        <Typography variant="body2">Applicable Income Taxes</Typography>

        <Typography variant="body2">
          - 1972-present - Represents the total of estimated federal, state,
          local and foreign income taxes (on an accrual basis) including the tax
          effects of gains or losses on securities not held in trading accounts
          and the tax benefits from operating loss carrybacks realized during
          the calendar year. Both the current and deferred portions are
          included. The benefits of operating loss carryforwards realized during
          the calendar year are included in extraordinary items.
        </Typography>

        <Typography variant="body2">
          - 1936-1971 - Reflects actual income taxes paid (cash basis) during
          each calendar year unless the bank maintains its books on an accrual
          basis.
        </Typography>

        <Typography variant="body2">
          - 1934-1935 - The amount of income taxes is included in Noninterest
          Expense - Occupancy.
        </Typography>

        <Typography variant="body2">Net Extraordinary Items</Typography>

        <Typography variant="body2">
          - 1969-present - Represents the results of material events and
          transactions that are both unusual and infrequent, net of income
          taxes.
        </Typography>

        <Typography variant="body2">
          Net Income - Represents the net result of all income less all
          expenses. Beginning in June 2009, Net Income (Loss) does not include
          Non-Controlling Interest. Net Income Attributable to Non Controlling
          Interest (NETIMIN) and Net Income - Bank and Non-Controlling Interests
          (NETINBM) are not included in table CB04.
        </Typography>

        <Typography variant="h2" id="Interest Income">
          Interest Income
        </Typography>

        <Typography variant="body2">General Comments</Typography>

        <Typography variant="body2">
          0 represents a positive amount less than $500
        </Typography>

        <Typography variant="body2">
          (0) represents a negative amount less than ($500)
        </Typography>

        <Typography variant="body2">NA -Not available</Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. Significant adjustments, changes or definitional differences
          from current requirements are identified or described. Comments
          describing changes in reporting practices relating to assets,
          liabilities and capital items are important in interpreting related
          income and expense items.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">
          Interest Income on Loans and Leases
        </Typography>

        <Typography variant="body2">
          Int Inc - Domestic Offices Loans
        </Typography>

        <Typography variant="body2">
          - 1934-present - Represents all interest, fees, and similar charges
          levied against or associated with all assets reportable as loans.
          Includes interest, yield related fees, commitment fees, service
          charges on loans and discount accretion.
        </Typography>

        <Typography variant="body2">Int Inc - Foreign Offices Loans</Typography>

        <Typography variant="body2">
          - 1981-present - Represents all interest, fees, and similar charges
          levied against or associated with all assets reportable as loans in
          foreign offices. Includes interest, yield related fees, commitment
          fees,service charges on loans and discount accretion.
        </Typography>

        <Typography variant="body2">
          - 1934-1980 - Interest and fees on loans in foreign offices are not
          available.
        </Typography>

        <Typography variant="body2">Int Inc - Leases</Typography>

        <Typography variant="body2">
          - 1976-present - Represents income and fees relating to direct
          financing and leveraged leases.
        </Typography>

        <Typography variant="body2">
          - 1934-1975 - Income from leases, if any, is included in Noninterest
          Income - All Other
        </Typography>

        <Typography variant="body2">
          Int Inc – Total Loans and Leases - Represents the total of Interest
          Income on Loans and Leases - Loans in Domestic Offices plus Loans in
          Foreign Offices plus All Leases
        </Typography>

        <Typography variant="body2">Int Inc - Investment Securities</Typography>

        <Typography variant="body2">
          - 1976-present - Represents interest and dividends, net of premium
          amortization and discount accretion, on all assets that are reportable
          as investment securities.
        </Typography>

        <Typography variant="body2">
          - 1934-1975 - Includes interest and dividends on securities held in
          trading accounts.
        </Typography>

        <Typography variant="body2">
          - 2001-present - Includes OTHER INTEREST INCOME.
        </Typography>

        <Typography variant="body2">
          Int Inc - Trading Account Assets
        </Typography>

        <Typography variant="body2">
          - 1984-present - &gt;Represents interest income earned on all trading
          account assets.
        </Typography>

        <Typography variant="body2">
          - 1934-1983 - The value is not available. Related income was included
          in other operating income (Noninterest Income - All Other).
        </Typography>

        <Typography variant="body2">
          Int Inc - Federal Funds Sold/Securities Purchased
        </Typography>

        <Typography variant="body2">
          - 1969-present - Represents gross income of all assets reportable
          under this category.
        </Typography>

        <Typography variant="body2">
          - 1934-1968 - This value was not reported separately and is included
          in Interest Income on Loans and Leases, Loans in Domestic Offices
        </Typography>

        <Typography variant="body2">Int Inc - Balances Due</Typography>

        <Typography variant="body2">
          - 1976-present - Represents income on balances due from other
          depository institutions.
        </Typography>

        <Typography variant="body2">
          - 1934-1975 - This value was not reported separately and is included
          in Noninterest Income - All Other.
        </Typography>

        <Typography variant="body2">
          Total Other Interest Income - Represents the sum of Other Interest
          Income - Investment Securities, Trading Account Assets, Federal Funds
          Sold and Securities Purchased, and Balances Due from Depository
          Institutions.
        </Typography>

        <Typography variant="body2">
          Total Interest Income - Represents the sum of Interest Income on Loans
          &amp; Leases - Total and Other Interest Income - Total
        </Typography>

        <Typography variant="h2" id="Interest Expense">
          Interest Expense
        </Typography>

        <Typography variant="body2">General Comments</Typography>

        <Typography variant="body2">
          0 represents a positive amount less than $500
        </Typography>

        <Typography variant="body2">
          (0) represents a negative amount less than ($500)
        </Typography>

        <Typography variant="body2">NA -Not available</Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. Significant adjustments, changes or definitional differences
          from current requirements are identified or described. Comments
          describing changes in reporting practices relating to assets,
          liabilities and capital items are important in interpreting related
          income and expense items.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">Interest on Deposits</Typography>

        <Typography variant="body2">
          Int Exp – Deposits in Domestic Offices - Represents all interest on
          all liabilities reportable as deposits in domestic offices. Includes
          finders' and brokers' fees that represent an adjustment to the
          interest paid on deposits acquired through brokers. Early withdrawal
          penalties or portions of such penalties that represent the forfeiture
          of interest are deducted from gross interest paid.
        </Typography>

        <Typography variant="body2">
          {" "}
          Int Exp – Deposits in Foreign Offices
        </Typography>

        <Typography variant="body2">
          - 1976-present - Represents all interest on all liabilities reportable
          as deposits in foreign offices.
        </Typography>

        <Typography variant="body2">
          - 1934-1975 - Interest on foreign office deposits is not available.
          Reports of Income were submitted on a domestic only basis.
        </Typography>

        <Typography variant="body2">
          Total Deposit Interest Expense - Represents the sum of Interest on
          Deposits - In Domestic Offices plus Interest on Deposits - In Foreign
          Offices
        </Typography>

        <Typography variant="body2">Other Interest Expense</Typography>

        <Typography variant="body2">
          Int Exp - Federal Funds Purchased/Securities Sold
        </Typography>

        <Typography variant="body2">
          - 1969-present - Represents the gross expenses of all liabilities
          reportable under this category.
        </Typography>

        <Typography variant="body2">
          - 1934-1968 - Included in Other Interest Expense - Borrowed Money.
        </Typography>

        <Typography variant="body2">
          Int Exp - Borrowed Money - Represents interest expense related to
          demand notes issued to the U. S. Treasury, mortgage indebtedness,
          obligations under capitalized leases, and other borrowed money.
        </Typography>

        <Typography variant="body2">
          Int Exp - Subordinated Notes - 1969-present - Represents interest
          expense related to subordinated notes and debentures.
        </Typography>

        <Typography variant="body2">
          - 1934-1968 - Includes interest and dividends paid on preferred stock.
        </Typography>

        <Typography variant="body2">
          Total Other Interest Expense - Represents the sum of Other Interest
          Expense - Federal Funds Purchased &amp; Securities Sold plus Borrowed
          Money plus Subordinated Notes and Debentures.
        </Typography>

        <Typography variant="body2">
          Total Interest Expense - Represents the total of Interest on Deposits
          - Total and Other Interest Expense - Total.
        </Typography>

        <Typography
          variant="h2"
          id="Noninterest Income and Noninterest Expense"
        >
          Noninterest Income and Noninterest Expense
        </Typography>

        <Typography variant="body2">General Comments</Typography>

        <Typography variant="body2">
          0 represents a positive amount less than $500
        </Typography>

        <Typography variant="body2">
          (0) represents a negative amount less than ($500)
        </Typography>

        <Typography variant="body2">NA -Not available</Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. Significant adjustments, changes or definitional differences
          from current requirements are identified or described. Comments
          describing changes in reporting practices relating to assets,
          liabilities and capital items are important in interpreting related
          income and expense items.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">Noninterest Income</Typography>

        <Typography variant="body2">
          Service Charges on Deposit Accounts
        </Typography>

        <Typography variant="body2">
          - 1942-present - Represents service charges on deposit accounts in
          domestic offices such as maintenance fees, activity charges,
          administrative charges, overdraft charges, and check certification
          charges.
        </Typography>

        <Typography variant="body2">
          - 1934-1941 - This value was not reported separately and is included
          in Noninterest Income - All Other.
        </Typography>

        <Typography variant="body2">Other Non-Interest Income</Typography>

        <Typography variant="body2">
          - 1969-present - Represents amounts of all other categories of
          noninterest income not included elsewhere. It includes income from
          fiduciary activities; gains, losses and fees relating to foreign
          currency or foreign exchange transactions; gains, losses and fees from
          assets held in trading accounts; net gains from the sale or
          disposition of loans, premises (including branches and offices) and
          fixed assets, and other real estate owned; all service charges, fees
          and commissions (other than those relating to deposits in domestic
          offices); fees charged on bank issued credit cards; net gains on
          futures and forward contracts; and other miscellaneous income.
        </Typography>

        <Typography variant="body2">
          - 1934-1968 - Source data have been adjusted to include net profits
          and recoveries on assets (other than loans or securities) sold or
          exchanged and all recoveries and reductions in valuation allowances
          (other than those relating to loans or securities) less all losses,
          charge-offs and additions to valuation allowances (other than those
          relating to loans or securities). Net losses are included in
          Noninterest
        </Typography>

        <Typography variant="body2"> Total Non-Interest Income</Typography>

        <Typography variant="body2">Expense - All Other.</Typography>

        <Typography variant="body2">
          - 1934-1941 - Includes service charges on deposit accounts.
        </Typography>

        <Typography variant="body2">
          - 2001-present - Includes AMORT &amp; IMPAIR LOSS AST.
        </Typography>

        <Typography variant="body2">
          Total - Represents the sum of Service Charges on Deposit Accounts and
          All Other.
        </Typography>

        <Typography variant="body2">Noninterest Expense</Typography>

        <Typography variant="body2">
          Employee Salaries &amp; Benefits
        </Typography>

        <Typography variant="body2">
          - 1961-present - Represents salaries, taxes and benefits of all
          officers and employees of the bank and its consolidated subsidiaries
          including guards, temporary office help, cafeteria employees, and
          building and maintenance employees.
        </Typography>

        <Typography variant="body2">
          - 1934-1960 - Does not include officer and employee benefits which are
          not separately reported and are included in Noninterest Expense - All
          Other.
        </Typography>

        <Typography variant="body2">
          - 1934-1935 - Includes fees paid to directors and committee members
          and professional fees which are not separately identified and should
          be included in Noninterest Expense - All Other.
        </Typography>

        <Typography variant="body2">Occupancy Expenses</Typography>
        <Typography variant="body2">
          - 1934-present - Represents all noninterest expense related to use of
          the banking premises, equipment, furniture and fixtures of the
          institution, whether owned or leased, net of any rental income
          received.
        </Typography>

        <Typography variant="body2">
          - 1934-1960 - Does not reflect the deduction of related income which
          is included in Noninterest Income - Other.
        </Typography>

        <Typography variant="body2">All Other Non-Interest Expense</Typography>

        <Typography variant="body2">
          - 1969-present - Represents amounts of all other categories of expense
          not included elsewhere. Includes fees paid to directors, trustees and
          advisory board members; premiums on fidelity insurance and deposit
          insurance; retainer and legal fees; net losses from the sale or
          disposition of loans, premises and fixed assets, other real estate
          owned, and branches; management fees assessed by parent bank holding
          companies; advertising, public relations, and promotional expenses;
          amortization expense of intangible assets; charitable contributions;
          net losses on futures and forward contracts; office supplies;
          telephone expenses; examination and audit fees; charge-offs and
          writedowns of securities prior to sale; and other miscellaneous
          expenses.
        </Typography>

        <Typography variant="body2">
          - 1934-1968 - Source data have been adjusted to include net losses
          (other than on loans or securities) and charge-offs on assets (other
          than on loans) and all charge-offs (on assets other than loans) and
          additions to valuation allowances (other than those relating to loans
          or securities)less all profits, recoveries and reductions in valuation
          allowances (other than those relating to loans or securities). Net
          profits are included in Noninterest Income - All Other.
        </Typography>

        <Typography variant="body2">
          - 1934-1960 - Includes officer and employee benefits which, beginning
          in 1961, are included in Noninterest Expense - Employee Salaries and
          Benefits.
        </Typography>

        <Typography variant="body2">
          - 1934-1935 - Does not include fees paid to directors and committee
          members and professional fees which are not separately identified and
          are included in Noninterest Expense - Employee Salaries and Benefits.
        </Typography>

        <Typography variant="body2">
          Total Non-Interest Expense - Represents the sum of Employee Salaries
          and Benefits, Occupancy Expenses, and All Other.
        </Typography>

        <Typography variant="h2" id="">
          Charge-offs and Recoveries on Loans/Leases, Cash Dividends and Number
          of Employees
        </Typography>

        <Typography variant="body2">General Comments</Typography>

        <Typography variant="body2">
          0 represents a positive amount less than $500
        </Typography>

        <Typography variant="body2">
          (0) represents a negative amount less than ($500)
        </Typography>

        <Typography variant="body2">NA -Not available</Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. Significant adjustments, changes or definitional differences
          from current requirements are identified or described. Comments
          describing changes in reporting practices relating to assets,
          liabilities and capital items are important in interpreting related
          income and expense items.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">Loan and Lease Charge-offs</Typography>

        <Typography variant="body2">
          - 1984-present - Represents actual loans and leases charged-off
          against the allowance for loan and lease losses.
        </Typography>

        <Typography variant="body2">
          - 1941-1983 - Represents actual loans charged-off against the reserve
          for bad debt losses on loans.
        </Typography>

        <Typography variant="body2">
          - 1934-1940 - Represents realized losses on loans, loans charged-off
          and additions to valuation allowances for loans, amounts that were
          reported as direct charges to undivided profits.
        </Typography>

        <Typography variant="body2">Loans and Lease Recoveries</Typography>

        <Typography variant="body2">
          - 1984-present - Represents actual loan and lease recoveries credited
          to the reserve for bad debt losses on loans.
        </Typography>

        <Typography variant="body2">
          - 1941-1983 - Represents actual loan recoveries credited to the
          allowance for loan and lease losses.
        </Typography>

        <Typography variant="body2">
          - 1934-1940 - Represents loan recoveries and reductions in the
          valuation allowance for loans.
        </Typography>

        <Typography variant="body2">
          Net Loan and Lease Charge-offs - Represents gross loans and lease
          charge-offs minus loan and lease recoveries. An amount enclosed in
          parentheses indicates net recoveries.
        </Typography>

        <Typography variant="body2">
          Cash Dividends Declared (Preferred)
        </Typography>

        <Typography variant="body2">
          - 1969-present - Represents all cash dividends declared on limited
          life and perpetual preferred stock during the calendar year,
          regardless of when payable.
        </Typography>

        <Typography variant="body2">
          - 1934-1968 - Cash dividends declared on preferred stock were reported
          with interest on capital notes and debentures, (Other Interest Expense
          - Subordinated Notes and Debentures).
        </Typography>

        <Typography variant="body2">
          Cash Dividends Declared (Common) - Represents all cash dividends
          declared on all classes of common stock during the calendar year,
          regardless of when payable.
        </Typography>

        <Typography variant="body2">
          Total Cash Dividends Declared - The total of cash dividends declared
          on all preferred and common stock during the calendar year, regardless
          of when payable.
        </Typography>

        <Typography variant="body2">Number of F/T Employees</Typography>

        <Typography variant="body2">
          - 1969-present - Represents the number of full time equivalent
          employees on the payroll as of each year end.
        </Typography>

        <Typography variant="body2">
          - 1934-1968 - Represents the total number of employees on the payroll
          as of each year end, including part time employees.
        </Typography>

        <Typography variant="body2">
          - 1935 - The number of employees does not include those of national
          banks.
        </Typography>

        <Typography variant="body2">
          - 1934 - The number of employees is as of June 30, 1934.
        </Typography>

        <Typography variant="h2" id="Assets">
          Assets
        </Typography>

        <Typography variant="body2">General Comments</Typography>

        <Typography variant="body2">
          0 represents a positive amount less than $500
        </Typography>

        <Typography variant="body2">
          (0) represents a negative amount less than ($500)
        </Typography>

        <Typography variant="body2">NA -Not available</Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. Significant adjustments, changes or definitional differences
          from current requirements are identified or described. Comments
          describing changes in reporting practices relating to assets,
          liabilities and capital items are important in interpreting related
          income and expense items.
        </Typography>

        <Typography variant="body2">9.2 Significant Events</Typography>

        <Typography variant="body2">
          1984 - All banks with $10 million or more in total consolidated assets
          are required to report assets and liabilities on an accrual basis.
        </Typography>

        <Typography variant="body2">
          A major form revision took place that eliminated the standard and
          abbreviated versions of the Reports of Income and Condition. They were
          replaced by four sets of reports:(1) FFIEC 031 filed by all banks that
          have foreign offices, including International Banking Facilities
          (IBFs), (2) FFIEC 032 filed by all banks with $300 million or more in
          total assets (3) FFIEC 033 filed by all banks with more than $100
          million but less than $300 million in total assets, and (4) FFIEC 034
          filed by all banks with less than $100 million in total assets.
        </Typography>

        <Typography variant="body2">
          1979 - The provision for possible loan losses based on management
          discretion replaces actual net loan losses.
        </Typography>

        <Typography variant="body2">
          1978 - An abbreviated Report of Condition was instituted for banks
          with less than $100 million in total consolidated assets.
        </Typography>

        <Typography variant="body2">
          1972 - Investment in subsidiaries not consolidated in which the bank
          directly or indirectly exercises control is to be reported on an
          equity basis.
        </Typography>

        <Typography variant="body2">
          Previously, the investment was reported on a cost basis.
        </Typography>

        <Typography variant="body2">
          1970 - Banks with total assets of $25 million or more are required to
          prepare their Call reports based on accrual accounting. All banks are
          required to report income taxes on a current accrual basis.
        </Typography>

        <Typography variant="body2">
          1969 - Banks with total assets of $50 million or more are required to
          report assets and liabilities on an accrual basis. Consolidation is
          required for all majority owned premises subsidiaries and other
          majority owned subsidiaries meeting level of significance tests.
        </Typography>

        <Typography variant="body2">
          1947 - On December 8, 1947 the Internal Revenue adopted the reserve
          method for accounting for bad debt losses on loans.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">
          Total Commercial Banks - Represents the total number of insured
          commercial banks filing a 12/31 financial report.
        </Typography>

        <Typography variant="body2">
          Cash and Due from Depository Institutions
        </Typography>

        <Typography variant="body2">
          - 1934-present - Represents currency and coin, interest and
          noninterest bearing balances due from banks and cash items.
        </Typography>

        <Typography variant="body2">
          - 1942-present - Demand deposits due from and due to banks in the
          United States exclude reciprocal interbank deposits.
        </Typography>

        <Typography variant="body2">Investment Securities</Typography>

        <Typography variant="body2">U.S. Treasury Securities</Typography>

        <Typography variant="body2" component="span">
          - 1934-present - Represents securities of the US Treasury; the US
          Government, both direct and guaranteed;
          <Typography variant="body2">
            {" "}
            US Agencies and Corporations Securities
          </Typography>{" "}
          - obligations of states, counties and municipalities; corporate bonds;
          other bonds, notes and debentures and equity securities. The amount is
          net of valuation reserves.
        </Typography>

        <Typography variant="body2">
          - 1984-present - Obligations (other than securities) of states,
          counties, and municipalities are reported as loans.
        </Typography>

        <Typography variant="body2">
          - 1965-1975 - Corporate stock is included in All Other Assets.
        </Typography>

        <Typography variant="body2">Total Loans and Leases</Typography>

        <Typography variant="body2">Total Real Estate Loans</Typography>

        <Typography variant="body2">Loans to Deposit Institutions</Typography>

        <Typography variant="body2"> Agricultural Loans</Typography>
        <Typography variant="body2">
          {" "}
          Commercial and Industrial Loans
        </Typography>
        <Typography variant="body2">Total Loans to Individuals </Typography>
        <Typography variant="body2">
          Loans to State &amp; Political Subdivisions
        </Typography>
        <Typography variant="body2">All Other Loans Leases</Typography>
        <Typography variant="body2"> Gross Loans and Leases </Typography>
        <Typography variant="body2">
          - 1976-present - Represents the total of all loans and leases, net of
          unearned income.
        </Typography>

        <Typography variant="body2">
          - 1934-1975 - Does not include lease financing receivables or direct
          lease financing.
        </Typography>

        <Typography variant="body2">
          - 1934-1978 - Deposits accumulated for the payment of personal loans
          are included in deposits and are not used to reduce the outstanding
          loan balances until maturity of the loans. In these instances banks,
          by contract with individual borrowers, set up a deposit account to
          accumulate loan payments made by individuals on personal installment
          loans.
        </Typography>

        <Typography variant="body2">
          - 1934-1975 - Unearned income is not reflected in total loans but is
          included in other liabilities.
        </Typography>

        <Typography variant="body2">
          - 1934-1963 - Includes Federal funds sold.
        </Typography>

        <Typography variant="body2">
          Allowance for Loan &amp; Lease Losses
        </Typography>

        <Typography variant="body2">
          - 1976-present - Beginning in 1976, the IRS reserve for bad debt
          losses on loans is divided as follows: (a) the
          &quot;valuation&quot;portion (plus any other loan loss reserve) is
          reflected as an offset against gross loans, (b) the &quot;deferred
          income tax portion&quot; is included in other liabilities, and (c) the
          &quot;contingency&quot; portion is included in undivided profits or
          reserve for contingencies and other capital reserves. The valuation
          portion is incremented by the amount that is a deductible expense for
          income tax purposes. The contingency portion is incremented by
          additional amounts that may be expensed by a bank for financial
          reporting purposes but is not a tax deductible expense.
        </Typography>

        <Typography variant="body2">
          - 1948-1975 - Represents the reserve for bad debt losses on loans as
          permitted by IRS ruling of December 8, 1947.
        </Typography>

        <Typography variant="body2">
          Net Loans and Leases - Gross loans and leases less the valuation
          reserve/allowance for possible losses on loans and leases.
        </Typography>

        <Typography variant="body2">Other Earning Assets</Typography>

        <Typography variant="body2">
          - 1934-present - Represents Federal funds sold, securities purchased
          under agreements to resell and trading account assets.
        </Typography>

        <Typography variant="body2">
          - 1984-present - Includes all trading account assets. Previously, they
          were reported in their respective asset category.
        </Typography>

        <Typography variant="body2">
          - 1969-present - Trading account securities included. In earlier years
          they are included in securities.
        </Typography>

        <Typography variant="body2">
          - 1967-present - Includes securities sold under agreements to
          repurchase. Previously they were included in loans.
        </Typography>

        <Typography variant="body2">
          - 1965-present - Includes Federal funds sold. Previously they were
          included in loans.
        </Typography>

        <Typography variant="body2">Bank Premises and Equipment</Typography>

        <Typography variant="body2">
          - 1934-present - Represents bank premises, furniture and equipment,
          net of depreciation.
        </Typography>
        <Typography variant="body2">
          - 1969-present - The value is gross of mortgage indebtedness which is
          included in other borrowed money.
        </Typography>

        <Typography variant="body2">
          - 1934-1968 - The value is reflected net of mortgage indebtedness.
        </Typography>

        <Typography variant="body2">Other Real Estate</Typography>

        <Typography variant="body2">
          - 1988-present - Represents real estate other than bank premises
          directly owned and direct and indirect investment in real estate
          ventures both by the bank and by its unconsolidated subsidiaries and
          associated companies.
        </Typography>

        <Typography variant="body2">
          - 1967-1988 - Represents real estate owned other than bank premises.
        </Typography>

        <Typography variant="body2">
          - 1938-1966 - Represents other real estate and investments in other
          assets indirectly representing bank premises or other real estate.
        </Typography>

        <Typography variant="body2">
          - 1934-1937 - Represents other real estate directly owned.
        </Typography>

        <Typography variant="body2">Intangible Assets</Typography>

        <Typography variant="body2">
          - 1983-present - Represents goodwill, mortgage servicing rights, and
          other identifiable intangible assets.
        </Typography>

        <Typography variant="body2">
          All Other Assets - Represents all other assets not included in
          previously mentioned captions. Includes, for the most part, customers'
          liabilities on acceptances outstanding, income earned not collected as
          well as any other asset not included above.
        </Typography>

        <Typography variant="body2">Total Assets</Typography>

        <Typography variant="body2">
          - 1974-present - The total of all assets net of security and loan
          valuation reserves/allowances. Assets and liabilities are reported on
          a fully consolidated, domestic and foreign basis.
        </Typography>

        <Typography variant="body2">
          - 1934-1973 - Assets and liabilities are reported on a domestic only
          basis. In the case of banks with one or more foreign branches, net
          amounts due from its own foreign branches are included in All Other
          Assets, net amounts due to its own foreign branches are included in
          All Other Liabilities. In the case of banks with branches outside the
          50 states (Guam, Puerto Rico, Virgin Islands, US Territories and
          Possessions), net amounts due from such branches are included in All
          Other Assets and net amounts due to such branches are included in All
          Other Liabilities.
        </Typography>

        <Typography variant="body2">
          - 1934-1969 - Assets and liabilities are reported on a cash or an
          accrual basis, depending upon each bank's method of bookkeeping.
        </Typography>

        <Typography variant="h2" id="Investment Securities">
          Investment Securities
        </Typography>

        <Typography variant="body2">General Comments</Typography>

        <Typography variant="body2">
          0 represents a positive amount less than $500
        </Typography>

        <Typography variant="body2">
          (0) represents a negative amount less than ($500)
        </Typography>

        <Typography variant="body2">NA -Not available</Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. Significant adjustments, changes or definitional differences
          from current requirements are identified or described. Comments
          describing changes in reporting practices relating to assets,
          liabilities and capital items are important in interpreting related
          income and expense items.
        </Typography>

        <Typography variant="body2">
          The dollar amounts in the table reflect the aggregate book value of
          securities, net of specific valuation reserves and net of premium
          amortization and discount accretion. With the exception of 1969 to
          1975, general (nonspecific) reserves on securities are reported in
          capital accounts. In 1969, banks were required to remove trading
          account securities from their investment securities portfolio and
          report them separately. Before 1969, any trading account securities
          held would have been included in the appropriate securities category.
          The &quot;small bank&quot; report form took effect in 1978. Less
          detail was reported by small banks but it did not affect the broader
          categories carried in this table. In 1984, the four existing report
          types took effect. Again, the extent of detail reported by small banks
          differed slightly from the detail reported by the larger banks. There
          is no effect on the amounts on this table. In 1984 marketable equity
          securities were required to be reported at the lower of cost or
          market, with the difference from book value being adjusted through an
          equity capital account. In 1994, all categories of securities were
          subdivided as either held-to-maturity or available-for-sale. The
          amount reflected in this table is the sum of the amortized cost (book
          value) of both of these breakdowns.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">U.S. Treasury Securities</Typography>

        <Typography variant="body2">
          - 1984-present - Represents all U.S. Treasury bonds, notes and bills
          and certificates of indebtedness. Current instructions state that
          those issued under the Separate Trading of Registered Interest and
          Principal of Securities (STRIPS) program are included. Detached
          Treasury security coupons and ex-coupon Treasury securities held
          either by stripping or through receipts such as CATS, TIGRs, COUGARs,
          LIONs and ETRs are not included here but are in other debt securities
          (&quot;Corporate bonds and other securities&quot; in this table).
        </Typography>

        <Typography variant="body2">
          - 1969-1984 - Represents U.S. Treasury bonds, notes, bills and
          certificates of indebtedness.
        </Typography>

        <Typography variant="body2">
          - 1965-1968 - Represents all U.S. Treasury bonds, notes, bills and
          certificates of indebtedness as well as obligations of U.S. government
          agencies and corporations that were guaranteed by the U.S. Government.
          Source data does not have the detail necessary to remove the amount of
          the guaranteed agency and corporation obligations.
        </Typography>

        <Typography variant="body2">
          - 1934-1964 - Represents all U.S. Treasury bonds, notes, bills and
          Certificates of Indebtedness. An adjustment was made to source data
          from 1946 to 1963 to remove the amount of guaranteed obligations
          Federal Housing Administration debentures) and place it in U.S.
          Agencies and Corporations.
        </Typography>

        <Typography variant="body2">
          U.S. Agencies and Corporations Securities
        </Typography>

        <Typography variant="body2">
          - 1994 - Mortgage backed securities(MBS) issued by government agencies
          or government sponsored corporations and by private issuers are
          reported separately. For this table, the amount of such MBSs issued by
          government agencies and government sponsored corporations are included
          here. All debt securities issued by government agencies (an
          instrumentality of the U.S. Government whose debt obligations are
          fully and explicitly guaranteed as to timely payment of principal and
          interest by the full faith and credit of the U.S. Government), and
          U.S. Government sponsored agencies (agencies originally established or
          chartered by the U.S. Government to serve public purposes specified by
          the U.S. Congress but whose debt obligations are not explicitly
          guaranteed by the full faith and credit of the U.S. Government) are
          included here. In addition to the direct debt, mortgage pass-through
          securities, collateralized mortgage obligations, real estate mortgage
          investment conduits, residuals and stripped securities, pool loan
          certificates, participation certificates, insured notes and
          certificates of beneficial ownership are also included. (Direct loans
          to agencies and corporations are not included and are part of loans
          and leases).
        </Typography>

        <Typography variant="body2">
          Over the sixty year period covered by this table, the following have
          been listed for inclusion:
        </Typography>

        <Typography variant="body2">
          Reconstruction Finance Corporation
        </Typography>

        <Typography variant="body2">Federal Housing Administration</Typography>

        <Typography variant="body2">
          Federal Farm Mortgage Corporation
        </Typography>

        <Typography variant="body2">
          Federal National Mortgage Association
        </Typography>

        <Typography variant="body2">Home Owner's Loan Corporation</Typography>

        <Typography variant="body2">
          International Bank for Reconstruction and Development
        </Typography>

        <Typography variant="body2">
          Federal Land Banks Federal Home Loan Banks
        </Typography>

        <Typography variant="body2">
          Federal Intermediate Credit Banks Export-Import Bank
        </Typography>

        <Typography variant="body2">
          Mutual Mortgage Insurance Corporation
        </Typography>

        <Typography variant="body2">Federal Financing Bank</Typography>

        <Typography variant="body2">Commodity Credit Corporation</Typography>

        <Typography variant="body2">
          Government National Mortgage Association
        </Typography>

        <Typography variant="body2">
          U.S. Housing Authority Banks for Cooperatives
        </Typography>

        <Typography variant="body2">Tennessee Valley Authority</Typography>

        <Typography variant="body2">Merchant Marine</Typography>

        <Typography variant="body2">U.S. Maritime Commission</Typography>

        <Typography variant="body2">D.C. Stadium Bonds</Typography>

        <Typography variant="body2">Farmers Home Administration</Typography>

        <Typography variant="body2">
          Trustees of Penn Central Transportation Co.
        </Typography>

        <Typography variant="body2">
          Department of Housing and Urban Development
        </Typography>

        <Typography variant="body2">Department of Transportation</Typography>

        <Typography variant="body2">General Services Administration</Typography>

        <Typography variant="body2">Small Business Administration</Typography>

        <Typography variant="body2">
          Federal Agricultural Mortgage Corporation
        </Typography>

        <Typography variant="body2">Federal Farm Credit Banks</Typography>

        <Typography variant="body2">
          Federal Home Loan Mortgage Corporation
        </Typography>

        <Typography variant="body2">Financing Corporation</Typography>

        <Typography variant="body2">Resolution Funding Corporation</Typography>

        <Typography variant="body2">
          Student Loan Marketing Association
        </Typography>

        <Typography variant="body2">U.S. Postal Service</Typography>

        <Typography variant="body2">
          - 1978-1993 - Certificates of participation issued by the Commodity
          Credit Corporation, Export-Import Bank, FHLMA, FNMA and Government
          National Mortgage Association (GNMA) and now reported as loans.
        </Typography>

        <Typography variant="body2">
          - 1970-1977 - Farmers Home Administration insured notes, which had
          been included in loans, are also added to this category.
        </Typography>

        <Typography variant="body2">
          - 1969 - Trading account securities are to be excluded. The
          distinction between guaranteed and not guaranteed is dropped from
          reporting instructions and all obligations of U.S. Government
          agencies, government sponsored agencies and government corporations
          are included here.
        </Typography>

        <Typography variant="body2">
          Certificates of participation issued by the Commodity Credit
          Corporation, Export-Import Bank, Federal Home Loan Mortgage
          Association (FHLMA) and Federal National Mortgage Association (FNMA)
          are also included.
        </Typography>

        <Typography variant="body2">
          - 1965-1968 - Represents obligations of U.S. agencies and corporations
          not guaranteed by the U.S. Government.
        </Typography>

        <Typography variant="body2">
          - 1961-1964 - Represents all obligations of U.S. agencies and
          corporations both guaranteed by the U.S. Government and not
          guaranteed.
        </Typography>

        <Typography variant="body2">
          - 1946-1960 - According to source documents, the amount reported here
          and reflected in this category on the table is the amount of U.S.
          Government guaranteed debentures issued by the Federal Housing
          Administration. It appears that there was no other government agency
          or corporation borrowing.
        </Typography>

        <Typography variant="body2">
          - 1942-1945 - Represents only obligations of the U.S. Government
          guaranteed by the U.S. Government. Obligations of U.S. agencies and
          corporations not guaranteed by the U.S. Government were reported in
          other bonds, notes and debentures and are included in &quot;Corporate
          bonds and other securities&quot;.
        </Typography>

        <Typography variant="body2">
          - 1934-1941 - Represents obligations of all U.S. agencies and
          corporations, both direct and guaranteed by the U. S. Government.
        </Typography>

        <Typography variant="body2">
          States &amp; Political Subdivisions Securities
        </Typography>

        <Typography variant="body2">
          - 1970-present - Represents all obligations (other than loans) of
          states and political subdivisions in the United States. This included
          the fifty states, the District of Columbia, and all counties,
          municipalities, school districts, irrigation districts, and drainage
          and sewer districts. Also include are the governments of Puerto Rico,
          and of the U.S. Territories and Possessions and their political
          subdivisions. Obligations included here are: securities, warrants, tax
          anticipation notes, general obligations, revenue obligations, local
          housing authority bonds, bonds of school, irrigation or drainage
          districts, Farmers Home Administration guaranteed loans made for rural
          community water supply, waste disposal systems and outdoor recreation
          centers, rated (nationally recognized rating agency) Industrial
          Development Bonds
        </Typography>

        <Typography variant="body2">
          - 1969 - Trading account securities are to be excluded.
        </Typography>

        <Typography variant="body2">
          - 1934-1968 - Represents all obligations (both loans to and securities
          of) States, counties and municipalities of the U.S. including Guam,
          Puerto Rico, the Virgin Islands and other U.S. Territories and
          Possessions.
        </Typography>

        <Typography variant="body2">
          Other Obligations - Corporate Bonds and Other Securities
        </Typography>

        <Typography variant="body2">
          - 1989-present - Represents all securities, bonds, notes and
          debentures of domestic and foreign corporations. Also includes
          privately issued or guaranteed mortgage backed securities and certain
          detached U.S. Government security coupons held as a result of either
          their purchase or the bank's stripping them (CATS, TIGRs, COUGARs,
          LIONs and ETRs.
        </Typography>

        <Typography variant="body2">
          - 1984-1988 - Includes equity securities.
        </Typography>

        <Typography variant="body2">
          - 1965-1975 - Includes equity securities.
        </Typography>

        <Typography variant="body2">
          - 1942-1960 - Includes obligations of U.S. agencies and corporations
          not guaranteed by the U.S. Government.
        </Typography>

        <Typography variant="body2">
          - 1934-1941 - Represents all debt securities, bonds, notes and
          debentures of privates corporations - railroads, real estate
          corporations, industrial corporations, other domestic corporations,
          foreign corporations, and foreign central, state, provincial and
          municipal governments. Also includes foreign equity securities and
          obligations of government agencies and corporations not guaranteed by
          the U.S. Government.
        </Typography>

        <Typography variant="body2">
          Other Obligations - Equity Securities
        </Typography>

        <Typography variant="body2">
          - 1989-present - Represents all equity securities not held for
          trading: investment in mutual funds, common stock of FNMA, Student
          Loan Marketing Association, Federal Home Loan Mortgage Corporation,
          Federal Reserve Bank stock, Federal Home Loan Bank stock, minority
          interests not meeting the definition of associated companies,
          &quot;restricted&quot; stock, and other equity securities in both
          domestic and foreign corporations.
        </Typography>

        <Typography variant="body2">
          - 1984-1988 - All equity securities for all banks are included in
          other securities and are included in &quot;Corporate bonds and other
          securities&quot;.
        </Typography>

        <Typography variant="body2">
          - 1978-1983 - Small bank call report takes effect in 1978. Equity
          securities are combined with all other securities on the report.
          Therefore, for small banks, the amount of equity securities is
          included in &quot;Corporate bonds and other securities&quot;.
        </Typography>

        <Typography variant="body2">
          - 1969 - Trading account securities are not included.
        </Typography>

        <Typography variant="body2">
          - 1938-1977 - Includes all preferred and common stock, mutual funds
          and Federal Reserve Stock.
        </Typography>

        <Typography variant="body2">
          - 1934-1937 - Does not include foreign stock.
        </Typography>

        <Typography variant="body2">Trading Account Securities</Typography>

        <Typography variant="body2">
          Valuation Reserves - For all years except 1969-1973, investment
          securities are reflected net of general valuation reserves.
        </Typography>

        <Typography variant="body2">
          Specific reserves are deducted from each security so reserved.
        </Typography>

        <Typography variant="body2">
          Total Investment Securities (Book Value) - 1969-present - Represents
          the amortized (book) value of all debt and equity securities, both
          domestic and foreign, net of valuation reserves (exception noted
          above). Trading account securities are not included.
        </Typography>

        <Typography variant="body2">
          - 1934-1968 - Represents the amortized (book) value of all debt and
          equity securities (including trading account securities), both
          domestic and foreign, net of valuation reserves (exception noted
          above).
        </Typography>

        <Typography variant="body2">Market Value</Typography>

        <Typography variant="body2">
          - 1984-present - Represents the market (fair) value of all investment
          securities.
        </Typography>

        <Typography variant="h2" id="">
          Loans and Leases
        </Typography>

        <Typography variant="body2">General Comments</Typography>

        <Typography variant="body2">
          0 represents a positive amount less than $500
        </Typography>

        <Typography variant="body2">
          (0) represents a negative amount less than ($500)
        </Typography>

        <Typography variant="body2">NA -Not available</Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. Significant adjustments, changes or definitional differences
          from current requirements are identified or described. Comments
          describing changes in reporting practices relating to assets,
          liabilities and capital items are important in interpreting related
          income and expense items.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">Real Estate Loans</Typography>

        <Typography variant="body2">
          - 1984-present - Represents all loans secured by real estate as
          evidenced by mortgages, deeds of trust, land contracts or other
          instruments,whether first or junior liens. Include regardless of
          purpose and regardless of whether the originated by the bank or
          purchased from others. Obligations of states, counties and
          municipalities, even if secured by real estate, are excluded and
          reported as obligations of states and political subdivisions. Notes
          issued and insured by the Farmers Home Administration and instruments
          (certificates of beneficial interest) representing an interest in
          Farmers Home Administration insured notes, formerly included in this
          category, are now to be reported as U.S. Government Agency and
          corporation securities.
        </Typography>

        <Typography variant="body2">
          - 1976-1983 - Represents all loans secured primarily by real estate
          represented by mortgages, deeds of trust, land contracts or other
          liens on real estate, whatever the purpose. Includes construction and
          permanent financing; VA guaranteed, FHA insured and conventional;
          loans secured by farmland; pass-through participations in pools of
          real estate mortgages.
        </Typography>

        <Typography variant="body2">
          - 1970-1975 - Represents all loans secured primarily by real estate
          represented by mortgages, deeds of trust, land contracts or other
          liens on real estate, whatever the purpose. Exclude pooled mortgages
          represented by certificates guaranteed by the Governments National
          Mortgage Association.
        </Typography>

        <Typography variant="body2">
          - 1934-1969 - Represents all loans secured by mortgages, deeds of
          trust, land contracts, or other liens on real estate. Includes
          farmland, improvements on farm land and residential properties.
        </Typography>

        <Typography variant="body2">
          Loans To Depository Institutions
        </Typography>

        <Typography variant="body2">
          - 1984-present - Represents all loans (other than those secured by
          real estate), including overdrafts, to banks, other depository
          institutions, and other associations, companies and financial
          intermediaries whose primary business is to accept deposits and to
          extend credit for business or for personal expenditures. Includes U.S.
          branches and agencies of foreign banks and foreign official banking
          institutions, all commercial banks chartered in the U.S., credit
          unions, mutual or stock savings banks, savings or building and loan
          associations, cooperative banks, industrial banks, thrift and loan
          associations, foreign domiciled branches of other U.S. banks and
          foreign banks and other similar depository institutions.
        </Typography>

        <Typography variant="body2">
          - 1976-1983 - Loans to real estate investment trusts is added to the
          definition below. The category includes loans to commercial banks,
          trust companies, industrial banks, stock and mutual savings banks,
          savings and loan associations, building and loan associations, private
          or unincorporated banks, real estate companies, mortgage lenders,
          mortgage servicers, mortgage originators, factoring companies,
          cooperative banks, credit unions, insurance companies, bank holding
          companies and loans directly to Federal lending institutions.
        </Typography>

        <Typography variant="body2">
          - 1970-1975 - Represents all loans to banks and other institutions,
          associations, companies and financial intermediaries that extend
          credit for business purposes or to finance personal expenditures.
          Purchases of mortgages and other loan paper under agreements to resell
          and participations in pool of loans not guaranteed by GNMA should be
          included if acquired from financial institutions. Federal funds sold
          and securities sold under agreements to repurchase are not included.
          Loans represented here include both direct loans and negotiable
          obligations purchased either from the issuing company or from dealers.
        </Typography>

        <Typography variant="body2">
          - 1969 - Represents all loans to banks and other institutions,
          associations, companies and financial intermediaries that extend
          credit for business purposes or to finance personal expenditures. Does
          not include Federal funds sold or securities purchased under resale
          agreements. Loans to industrial development authorities not secured by
          real estate are still included.
        </Typography>

        <Typography variant="body2">
          - 1965-1968 - Same as 1961 below, Federal funds are no longer included
          but are reported separately.
        </Typography>

        <Typography variant="body2">
          - 1961-1964 - Represents all loans to banks and other institutions,
          associations, companies and financial intermediaries that extend
          credit for business purposes or to finance personal expenditures.
          Includes loans to regional or local industrial development authorities
          whose function it is to extend credit to business firms to assist in
          relocation or expansion (unless the loans are secured by real estate),
          loans to purchase securities from financial institutions under resale
          agreements and Federal funds sold.
        </Typography>

        <Typography variant="body2">
          - 1959-1960 - Represents notes, certificates of deposit given for the
          purpose of borrowing money, and other instruments evidencing loans to
          operating domestic financial and foreign financial institutions,
          including Federal funds sold by the reporting bank to another bank.
          Added to this category are the purchases of securities from banks
          under resale agreements or similar transactions. The scope of this
          category now includes loans to savings banks, savings and loan
          associations, finance companies and other financial intermediaries.
        </Typography>

        <Typography variant="body2">
          - 1934-1958 - Represents notes, certificates of deposit and other
          instruments evidencing loans to operating domestic and foreign banks,
          including Federal funds sold.
        </Typography>

        <Typography variant="body2">Agricultural Loans</Typography>

        <Typography variant="body2">
          - 1984-present - Represents all secured and unsecured loans and
          advances made to finance agricultural production and other loans to
          farmers. Includes loans to farm or ranch owners or operators,
          including tenants, except loans secured by real estate, borrowings for
          commercial or industrial purposes, for the purpose of purchasing or
          carrying securities or loans directly guaranteed by or participation
          certificates of the Commodity Credit Corporation. Included are loans
          for purchasing private passenger automobiles, tractors, farm
          implements and retail consumer goods on the installment basis.
          Includes loans for purposes such as growing and storing of crops;
          marketing or carrying of agricultural products; breeding, raising,
          fattening, or marketing livestock; financing fisheries and forestries;
          notes of farmers that have been discounted for or purchased from
          merchants or dealers.
        </Typography>

        <Typography variant="body2">
          - 1978-1983 - Represents all secured and unsecured loans and advances
          made to finance agricultural production and other loans to farmers.
          Includes loans to farm or ranch owners or operators, including
          tenants, except loans secured by real estate, borrowings for
          commercial or industrial purposes, for the purpose of purchasing or
          carrying securities or loans directly guaranteed by or participation
          certificates of the Commodity Credit Corporation. Included are loans
          for purchasing private passenger automobiles, tractors, farm
          implements and retail consumer goods on the installment basis.
        </Typography>

        <Typography variant="body2">
          - 1976-1977 - Represents all secured and unsecured loans and advances
          made to farm or ranch owners or operators, including tenants, except
          loans secured by real estate, borrowings for commercial or industrial
          purposes, for the purpose of purchasing or carrying securities or
          loans directly guaranteed by or participation certificates of the
          Commodity Credit Corporation. Included are loans for purchasing
          private passenger automobiles, tractors, farm implements and retail
          consumer goods on the installment basis.
        </Typography>

        <Typography variant="body2">
          - 1961-1975 - Represents all secured and unsecured loans and advances
          made to farm or ranch owners or operators, including tenants, except
          loans secured by real estate, borrowings for commercial or industrial
          purposes, for the purpose of purchasing or carrying securities or
          loans directly guaranteed by or participation certificates of the
          Commodity Credit Corporation.
        </Typography>

        <Typography variant="body2">
          - 1936-1960 - Represents all loans to farmers and loans for
          agricultural production. Loans secured by farmland and improvements to
          or on farmland are included above in real estate mortgages.
        </Typography>

        <Typography variant="body2">
          - 1934-1935 - Loans for agricultural production and loans to farmers
          are included in &quot;All Other Loans&quot;.
        </Typography>

        <Typography variant="body2">Commercial and Industrial Loans</Typography>

        <Typography variant="body2">
          - 1984-present - Represents loans for commercial and industrial
          purposes to sole proprietorships, partnerships, corporations and other
          business enterprises, whether secured (other than by real estate) or
          unsecured, single payment or installment. These loans may take the
          form of direct or purchased loans and include the reporting bank's own
          acceptances that it holds in its portfolio. It also included loans to
          individuals for commercial, industrial or professional purposes but
          not for investment or personal expenditure purposes. Excludes all
          commercial loans held in trading accounts, loans to depository
          institutions, loans to nondepository financial institutions, loans to
          nonprofit organizations, and equipment trust certificates.
        </Typography>

        <Typography variant="body2">
          - 1961-1983 - Represents all secured (except by real estate) and
          unsecured business loans, both single payment and installment, to sole
          proprietorships, partnerships and corporations. Also includes
          acceptances and commercial paper bought on the open market,
          construction loans if not secured by a lien on real estate, SBA
          guaranteed loans, vehicle floor plan and wholesale financing loans,
          credit extended under business credit cards.
        </Typography>

        <Typography variant="body2">
          - 1938-1960 - Represents all secured (except by real estate) and
          unsecured business loans to individuals, partnerships and
          corporations. Also includes commercial paper bought on the open
          market.
        </Typography>

        <Typography variant="body2">
          - 1934-1958 - Includes commercial paper of and loans to financial
          institutions other than domestic commercial and foreign banks.
        </Typography>

        <Typography variant="body2">
          - 1934-1937 - Represents commercial paper purchased on the open
          market. Other commercial and industrial loans are included in
          &quot;All Other Loans&quot;.
        </Typography>

        <Typography variant="body2">Loans to Individuals</Typography>

        <Typography variant="body2">
          - 1942-present - Represents all loans to individuals for household,
          family and other personal expenditures. Includes loans to finance
          autos, pickup trucks, home improvement, medical expenses, personal
          taxes, household appliances, furniture, jewelry, education, student
          loans, mobile homes, trailers, boats, the purchase of real estate if
          not secured by a mortgage, and other personal expenses. It includes
          demand, installment and single payment loans regardless of form taken:
          direct and indirect credit, retail installment sales paper purchased
          by the bank, check credit, credit card, revolving credit and other
          similar forms of credit. Does not include loans to individuals for
          business or professional purposes, loans to farmers, loans secured by
          real estate or loans to purchase or carry securities.
        </Typography>

        <Typography variant="body2">
          - 1934-1941 - Loans to individuals are included in &quot;All Other
          Loans&quot;.
        </Typography>

        <Typography variant="body2">
          Loans to State &amp; Political Subdivisions
        </Typography>

        <Typography variant="body2">
          - 1989-present - Represents obligations (other than securities and
          leases) of states and political subdivisions in the U.S. States and
          political subdivisions includes the fifty states, the District of
          Columbia and their counties, municipalities, school districts,
          irrigation districts, and drainage and sewer districts; also includes
          the governments of Puerto Rico and of the U.S. Territories and
          Possessions and their political subdivisions. Industrial development
          bonds (IDBs): if rated by a nationally recognized rating service, they
          are included in investment securities, if not rated, they are included
          here unless the bank chooses to review each to see if it has the
          characteristics of a loan or of a security.
        </Typography>

        <Typography variant="body2">
          - 1984-1988 - Represents all obligations (other than securities),
          direct loans, overdrafts and nonrated industrial development bonds
          that have the characteristics of loans and are not secured by real
          estate.
        </Typography>

        <Typography variant="body2">
          - 1934-1983 - Loans, industrial development bonds (not secured by real
          estate) and other obligations of states and political subdivisions
          were usually included in investment securities.
        </Typography>

        <Typography variant="body2">All Other Loans</Typography>

        <Typography variant="body2">
          - 1983-present - Represents unplanned overdrafts and loans to: brokers
          and dealers in securities, any borrower for the purpose of purchasing
          and carrying securities, nonprofit institutions and organizations,
          individuals for investment purposes, real estate investment trusts,
          mortgage companies holding companies of depository institutions,
          insurance companies, finance companies, factors and other financial
          intermediaries, federally sponsored lending agencies, investment
          banks, the bank's own trust department, Small Business Investment
          Companies, foreign governments and official institutions, and any
          other loan not included in one of the above categories.
        </Typography>

        <Typography variant="body2">
          - 1969-1983 - Represents overdrafts and loans to: churches, hospitals,
          educational and charitable institutions, clubs and similar
          organizations, nonprofit organizations, foreign governments and
          official institutions, foreign central banks, foreign development
          banks, to the bank's own trust department, and any other loan not
          included in one of the above categories.
        </Typography>

        <Typography variant="body2">
          - 1938-1968 - Represents overdrafts, leases, and loans to:
          individuals, nonprofit organizations, foreign central banks and
          nationalized banking institutions, international financing banks (Bank
          for Reconstruction and Development, Inter-American Development bank),
          to the bank's own trust department, and any other loan not included in
          one of the above categories.
        </Typography>

        <Typography variant="body2">
          - 1936-1937 - Represents commercial and industrial loans, leases,
          overdrafts and loans to: individuals, nonprofit organizations, foreign
          central banks and nationalized banking institutions, and any other
          loan not included in one of the above categories.
        </Typography>

        <Typography variant="body2">
          - 1934-1935 - Represents loans to: financial institutions, farmers,
          individuals, nonprofit organizations, foreign central banks and
          nationalized banking institutions, and any other loan not included in
          one of the above categories. Includes all commercial and industrial
          loans, all overdrafts in deposit accounts and any leasing receivables.
        </Typography>

        <Typography variant="body2">Lease Financing Receivables</Typography>

        <Typography variant="body2">
          - 1973-present - Represents all outstanding receivable balances
          relating to direct financing and leveraged leases on property acquired
          by the bank for leasing purposes, net of unearned income.
        </Typography>

        <Typography variant="body2">
          - 1934-1972 - The amount of lease financing and leased property was
          not available. If a bank entered into any such transactions, it
          probably reflected the value of the property acquired for lease as an
          other asset. Other types of leases lease financing were probably
          included in loans.
        </Typography>

        <Typography variant="body2">Gross Loans &amp; Leases</Typography>

        <Typography variant="body2">
          - 1934-present - Represents the sum of all components of loans.
        </Typography>

        <Typography variant="body2">Unearned Income</Typography>

        <Typography variant="body2">
          - 1973-present - Represents the amount of income collected but not
          earned on loans.
        </Typography>

        <Typography variant="body2">
          - 1934-1972 - Unearned income was included in all other liabilities.
        </Typography>

        <Typography variant="body2">
          Allowance for Loan and Lease Losses
        </Typography>

        <Typography variant="body2">
          - 1976-present - Represents the allowance for possible loan and lease
          losses.
        </Typography>

        <Typography variant="body2">
          - 1934-1983 - Does not include an allowance for possible losses on
          leases.
        </Typography>

        <Typography variant="body2">
          - 1948-1975 - Represents the reserve for bad debt losses on loans as
          permitted by IRS ruling of December 8, 1947.
        </Typography>

        <Typography variant="body2">Net Loans &amp; Leases</Typography>

        <Typography variant="body2">
          - 1934-present - Represents gross loans and leases less unearned
          income and the allowance for possible losses on loans and leases.
        </Typography>

        <Typography variant="body2">
          - 1978-present - All values are fully consolidated, domestic and
          foreign.
        </Typography>

        <Typography variant="body2">
          - 1974-1977 - The loan components are domestic only, U.S. and other
          areas; the amount of loans in foreign offices has been added to the
          Net Loans and Leases column.
        </Typography>

        <Typography variant="body2">
          - 1934-1973 - All loan components and totals are domestic only, U.S.
          and other areas.
        </Typography>

        <Typography variant="body2">Real Estate Loans</Typography>

        <Typography variant="h2" id="General Comments">
          General Comments
        </Typography>

        <Typography variant="body2">
          0 represents a positive amount less than $500
        </Typography>

        <Typography variant="body2">
          (0) represents a negative amount less than ($500)
        </Typography>

        <Typography variant="body2">NA -Not available</Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. Significant adjustments, changes or definitional differences
          from current requirements are identified or described. Comments
          describing changes in reporting practices relating to assets,
          liabilities and capital items are important in interpreting related
          income and expense items.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">
          Domestic Office Loans Secured by Real Estate
        </Typography>

        <Typography variant="body2">
          R/E Loans - Construction and Land Development
        </Typography>

        <Typography variant="body2">
          - 1984-present - Represents loans secured by real estate with
          maturities of 60 months or less made to finance land development or
          the on-site construction of industrial, commercial, residential or
          farm buildings. Includes new construction, additions or alterations to
          existing structures and razing existing structures to make way for new
          structures. Industrial development bonds are not included here any
          longer, they are reported as securities of states, counties and
          municipalities (if rated) or in loans to states and political
          subdivisions if not rated.
        </Typography>

        <Typography variant="body2">
          - 1976-1983 - Represents loans secured primarily by real estate the
          proceeds of which will be used to finance:
        </Typography>

        <Typography variant="body2">
          the construction of industrial, commercial, residential or farm
          buildings
        </Typography>

        <Typography variant="body2">
          the acquisition, conversion and development of property into improved
          real estate
        </Typography>

        <Typography variant="body2">
          the construction of additions or alterations to existing structures
        </Typography>

        <Typography variant="body2">
          the demolition of existing structures in preparation for new
          construction
        </Typography>

        <Typography variant="body2">
          loans to regional or local industrial development authorities who
          supply credit to business
        </Typography>

        <Typography variant="body2">
          firms to assist in relocation or expansion
        </Typography>

        <Typography variant="body2">
          - 1934-1975 - Loans for the above purposes could have been included in
          any of the other categories of loans in this table.
        </Typography>

        <Typography variant="body2">R/E Loans - 1-4 Family</Typography>

        <Typography variant="body2">
          - 1968-present - Represents permanent loans secured by real estate as
          evidenced by mortgages (FHA, VA, or conventional) or other liens on
          1-4 family dwelling units, mobile homes, individual condominiums and
          co-ops, and vacant lots in established single family residential
          sections.
        </Typography>

        <Typography variant="body2">
          - 1934-1968 - Includes permanent loans secured by real estate on both
          1-4 family and on multifamily residential properties.
        </Typography>

        <Typography variant="body2">R/E Loans Multifamily </Typography>

        <Typography variant="body2">
          - 1969-present - Represents permanent nonfarm residential loans
          secured by real estate as evidenced by mortgages (FHA and
          conventional)or other liens on nonfarm properties with 5 or more
          dwelling units in apartments, housekeeping dwellings, co-operative
          type apartment buildings, and vacant lots in established multifamily
          residential sections.
        </Typography>

        <Typography variant="body2">
          - 1934-1968 - Multifamily residential real estate loans are included
          in &quot;1-4 Family Residential Properties&quot;.
        </Typography>

        <Typography variant="body2">R/E Loans Farmland</Typography>

        <Typography variant="body2">
          - 1934-present -Represents loans secured by farmland, including
          improvements, and other land known to be used or usable for
          agricultural purposes, as evidenced by mortgages or other liens. It
          includes loans secured by farmland that are guaranteed by the Farmers
          Home Administration (FHA) or by the Small Business Administration.
        </Typography>

        <Typography variant="body2">
          R/E Loans Nonfarm, Nonresidential
        </Typography>

        <Typography variant="body2">
          - 1938-present - Represents loans secured by real estate as evidenced
          by mortgages or other liens on business and industrial properties,
          hotels, motels, churches, hospitals, educational and charitable
          institutions, dormitories, clubs, lodges, association buildings, homes
          for aged persons, golf courses, recreational facilities and other
          similar properties.
        </Typography>

        <Typography variant="body2">
          - 1934-1937 - These loans are included in &quot;1-4 family residential
          properties&quot;.
        </Typography>

        <Typography variant="body2">
          Total R/E loans in Domestic Offices - Represents the sum of all
          components of loans secured by real estate.
        </Typography>

        <Typography variant="body2">
          {" "}
          Total R/E loans in Foreign Offices - 1978-present - Represents all
          loans secured by real estate in foreign offices.
        </Typography>

        <Typography variant="body2">Total Real Estate Loans</Typography>

        <Typography variant="body2">
          - 1978-present - Represents the total of all loans secured by real
          estate in domestic and foreign offices.
        </Typography>

        <Typography variant="body2">
          - 1934-1977 - Represents the total of all loans secured by real estate
          in domestic offices (U.S. and other areas).
        </Typography>

        <Typography variant="h2" id="Loans to Individuals">
          Loans to Individuals
        </Typography>

        <Typography variant="body2">General Comments</Typography>

        <Typography variant="body2">
          0 represents a positive amount less than $500
        </Typography>

        <Typography variant="body2">
          (0) represents a negative amount less than ($500)
        </Typography>

        <Typography variant="body2">NA -Not available</Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. Significant adjustments, changes or definitional differences
          from current requirements are identified or described. Comments
          describing changes in reporting practices relating to assets,
          liabilities and capital items are important in interpreting related
          income and expense items.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">
          Loans to Individuals - Credit Card and Related Plans
        </Typography>

        <Typography variant="body2">
          - 1967-present - Represents all credit extended to individuals for
          household, family and other personal expenditures through credit cards
          and related plans. Includes check credit and other revolving credit
          plans. This amount reflects values in domestic offices only.
        </Typography>

        <Typography variant="body2">
          - 2001-present - includes LNS-CREDIT CD &amp; RELATED PLAN.
        </Typography>

        <Typography variant="body2">
          {" "}
          Loans to Individuals - All Other
        </Typography>

        <Typography variant="body2">
          - 1934-present - Represents all other loans to individuals for
          household, family and other personal expenditures. It includes auto
          loans, both direct and indirect, mobile homes (unless secured by a
          real estate mortgage), education loans, other installment loans both
          secured by personal property or unsecured, and single payment loans
          (time or demand, secured or unsecured).
        </Typography>

        <Typography variant="body2">
          Memo: - These components are not currently reported separately. The
          amounts for earlier years are provided for informational purposes.
        </Typography>

        <Typography variant="body2"> Loans to Individuals - Auto</Typography>

        <Typography variant="body2">- 1960-1980 -</Typography>

        <Typography variant="body2">
          - 1942-1946 - Represents installment loans to purchase private
          passenger automobiles, both direct loans and purchased paper.
        </Typography>

        <Typography variant="body2">- 1947-1959 -</Typography>

        <Typography variant="body2">
          - 1934-1941 - Auto loans are included in All Other
        </Typography>

        <Typography variant="body2">
          {" "}
          Loans to Individuals - Mobile Homes
        </Typography>

        <Typography variant="body2">
          - 1971-1980 - Represents loans to individuals to purchase mobile
          homes. (If the bank's security interest in the loan was represented by
          a mortgage or deed of trust, the loan should be included in real
          estate loans).
        </Typography>

        <Typography variant="body2">
          - 1934-1970 - Mobile home loans (other than those secured by a
          mortgage) are included in All Other.
        </Typography>

        <Typography variant="body2">
          {" "}
          Loans to Individuals - Single Payment
        </Typography>

        <Typography variant="body2">
          - 1960-1980, 1942-1946 - All loans both time or demand, secured or
          unsecured, to individuals for personal, family or other household
          expenditures.
        </Typography>

        <Typography variant="body2">
          - 1947-1959, 1934-1941 - Single payment loans are included in All
          Other.
        </Typography>

        <Typography variant="body2">
          Total Loans to Individuals - Represents the sum of all components of
          loans to individuals.
        </Typography>

        <Typography variant="h2" id="Liabilities and Equity Capital">
          Liabilities and Equity Capital
        </Typography>

        <Typography variant="body2">General Comments</Typography>

        <Typography variant="body2">
          0 represents a positive amount less than $500
        </Typography>

        <Typography variant="body2">
          (0) represents a negative amount less than ($500)
        </Typography>

        <Typography variant="body2">NA -Not available</Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. Significant adjustments, changes or definitional differences
          from current requirements are identified or described. Comments
          describing changes in reporting practices relating to assets,
          liabilities and capital items are important in interpreting related
          income and expense items.
        </Typography>

        <Typography variant="body2">Significant Events</Typography>

        <Typography variant="body2">
          1984 - All banks with $10 million or more in total consolidated assets
          are required to report assets and liabilities on an accrual basis. A
          major reporting revision took place that initiated four reporting form
          sets: (1) FFIEC 031 filed by all banks that have one or more foreign
          offices, including International Banking Facilities (IBFs), (2) FFIEC
          032 filed by all banks with $300 million or more in total assets, (3)
          FFIEC 033 filed by all banks with more than $100 million but less than
          $300 million in total assets, and (4) FFIEC 034 filed by all banks
          with less that $100 million in total assets.
        </Typography>

        <Typography variant="body2">
          1978 - An abbreviated Report of Condition was instituted for banks
          with less than $100 million in total consolidated assets.
        </Typography>

        <Typography variant="body2">
          1970 - Banks with total assets of $25 million or more are required to
          report assets and liabilities on an accrual basis. All banks are
          required to report income taxes on an accrual basis.
        </Typography>

        <Typography variant="body2">
          1969 - Banks with total assets of $50 million or more are required to
          report assets and liabilities on an accrual basis. Consolidation is
          required for all majority owned bank premises subsidiaries and other
          majority owned subsidiaries meeting level of significance tests.
        </Typography>

        <Typography variant="body2">
          1947 - On December 8, 1947 the Internal Revenue Service adopted the
          reserve method of accounting for bad debt losses on loans.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">
          Total Commercial Banks Institutions - Represents the total number of
          insured commercial filing a 12/31 financial report.{" "}
        </Typography>

        <Typography variant="body2">
          Total Deposits - Represents all categories and types of deposits.
        </Typography>

        <Typography variant="body2">Borrowed Funds</Typography>

        <Typography variant="body2">
          - 1969-present - Represents Federal funds purchased, securities sold
          under agreements to repurchase, demand notes issued to the US
          Treasury, mortgage indebtedness, liabilities under capitalized leases
          and all other liabilities for borrowed money.
        </Typography>

        <Typography variant="body2">
          - 1934-1968 - Does not include mortgage indebtedness which is netted
          against bank premises.
        </Typography>

        <Typography variant="body2">
          Subordinated Notes and Debentures
        </Typography>

        <Typography variant="body2">
          - 1944-present - Represents all notes and debentures subordinated to
          deposits and all capital notes and debentures.
        </Typography>

        <Typography variant="body2">
          - 1934-1943 - Does not include capital notes and debentures which are
          included in common stock.
        </Typography>

        <Typography variant="body2">Other Liabilities</Typography>

        <Typography variant="body2">
          - 1934-present - Represents all liabilities not included above.
        </Typography>

        <Typography variant="body2">
          - 1980-1984 - Includes limited life preferred stock.
        </Typography>

        <Typography variant="body2">
          - 1934 - Includes circulating notes outstanding.
        </Typography>

        <Typography variant="body2">
          - 1994-present - Trading account liabilities were added as a separate
          category
        </Typography>

        <Typography variant="body2">
          - 2001-present - Includes OTHER LIAB &amp; MINOR IN SUBS.
        </Typography>

        <Typography variant="body2">
          Total Liabilities - Represents the total of all components of
          liabilities.
        </Typography>

        <Typography variant="body2">Equity Capital</Typography>

        <Typography variant="body2">Perpetual Preferred Stock</Typography>

        <Typography variant="body2">
          - 1944-present - Represents all perpetual preferred stock issued and
          outstanding. Limited life preferred stock is included in Other
          Liabilities.
        </Typography>

        <Typography variant="body2">
          - 1934-1943 - Preferred stock was not reported separately and is
          included in common stock.
        </Typography>

        <Typography variant="body2">Common stock</Typography>

        <Typography variant="body2">
          - 1944-present - Represents the par value of all common stock issued
          and outstanding.
        </Typography>

        <Typography variant="body2">
          - 1934-1943 - Represents capital notes and debentures and preferred
          stock.
        </Typography>

        <Typography variant="body2">
          Surplus - 1934-present - Represents surplus and surplus related
          accounts.
        </Typography>

        <Typography variant="body2">Undivided Profits</Typography>

        <Typography variant="body2">
          - 1934-present - Represents undivided profits and related accounts.
        </Typography>

        <Typography variant="body2">
          - 1984-1990 - Includes foreign currency translation adjustment
          account.
        </Typography>

        <Typography variant="body2">Other Capital</Typography>

        <Typography variant="body2">
          - 1976-present - Current reporting requirements do not recognize this
          segregation of capital.
        </Typography>

        <Typography variant="body2">
          - 1969-1975 - Represents reserves for contingencies, other loan
          reserves and other capital reserves.
        </Typography>

        <Typography variant="body2">
          - 1934-1968 - Represents reserve for contingencies and other capital
          reserves.
        </Typography>

        <Typography variant="body2">
          -2001-present - Includes OTHER EQUITY CAPITAL COMPONENTS.
        </Typography>

        <Typography variant="body2">
          Total Equity Capital - Represents the sum of all capital accounts.
        </Typography>

        <Typography variant="body2">
          Total Liabilities and Equity Capital
        </Typography>

        <Typography variant="body2">
          - 1934-present - Represents the sum of all deposit, liability and
          capital accounts.
        </Typography>

        <Typography variant="body2">
          - 1974-present - Reported on a fully consolidated domestic and foreign
          basis.
        </Typography>

        <Typography variant="body2">
          - 1934-1973 - Reported on a domestic only basis. Amounts due from
          foreign offices or offices outside the United States are included in
          other assets. Amounts due to foreign offices or offices outside the
          United States are included in other liabilities.
        </Typography>

        <Typography variant="body2">
          - 2009 - Total Liability and Equity includes Equity from Non
          Controlling Interest (eqconsub).
        </Typography>

        <Typography variant="h2" id="Deposits">
          Deposits
        </Typography>

        <Typography variant="body2">General Comments</Typography>

        <Typography variant="body2">
          0 represents a positive amount less than $500
        </Typography>

        <Typography variant="body2">
          (0) represents a negative amount less than ($500)
        </Typography>

        <Typography variant="body2">NA -Not available</Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. Significant adjustments, changes or definitional differences
          from current requirements are identified or described. Comments
          describing changes in reporting practices relating to assets,
          liabilities and capital items are important in interpreting related
          income and expense items.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">Deposits/Domestic and Foreign</Typography>

        <Typography variant="body2">
          Deposits of Individuals, Partnerships and Corporations
        </Typography>

        <Typography variant="body2">
          - 2001-Beginning in 2001, Deposits of Individuals, Partnerships and
          Corporations includes certified and official checks.
        </Typography>

        <Typography variant="body2">
          - 1984-present - Represents all deposits of individuals, partnerships
          and corporations in domestic and foreign offices.
        </Typography>

        <Typography variant="body2">
          - 1991 - NOTE: The edition included deposits of individuals,
          partnerships and corporations in domestic offices only.
        </Typography>

        <Typography variant="body2">
          - 1934-1983 - Represents all deposits of individuals, partnerships and
          corporations in domestic offices.
        </Typography>

        <Typography variant="body2">Deposits of U.S. Government</Typography>

        <Typography variant="body2">
          - 1934-present - Represents all deposits of the U.S. Government in
          domestic offices. Such deposits, if any, in foreign offices are not
          reported separately.
        </Typography>

        <Typography variant="body2">
          - 1934-1975 - Does not include savings accounts. (The U.S. Government
          was not permitted to hold insured savings accounts until 1976).
        </Typography>

        <Typography variant="body2">
          - 1934-1964 - Includes postal savings deposits.
        </Typography>

        <Typography variant="body2">
          Deposits of States and Political Subdivisions in the United States
        </Typography>

        <Typography variant="body2">
          - 1934-present - Represents all deposits of states, counties and
          municipalities in domestic offices. Such deposits, if any, in foreign
          offices are not separately reported.
        </Typography>

        <Typography variant="body2">
          - 1934-1975 - Does not include savings accounts. (Such entities were
          not permitted to hold insured savings deposits until 1976).
        </Typography>

        <Typography variant="body2">Deposits of All Other</Typography>

        <Typography variant="body2">
          - 1984-present - Represents all other deposits. Includes deposits of
          financial institutions, both domestic and foreign, deposits of foreign
          governments and official institutions and certified and official
          checks. Also includes deposits in foreign offices other than those of
          individuals, partnerships and corporations.
        </Typography>

        <Typography variant="body2">
          NOTE: The 1991 edition reflected all deposits in foreign offices in
          this column, including those of individuals, partnerships and
          corporations.
        </Typography>

        <Typography variant="body2">
          - 1934-1983 - Represents all other deposits. Includes deposits of
          financial institutions, both domestic and foreign, deposits of foreign
          governments and official institutions and certified and official
          checks. Also includes all deposits in foreign offices.
        </Typography>

        <Typography variant="body2">
          Total Deposits, Domestic and Foreign Offices
        </Typography>

        <Typography variant="body2">
          - 1974-present - Represents the sum of total deposits on a domestic
          and foreign consolidated basis.
        </Typography>

        <Typography variant="body2">
          - 1934-1973 - Represents the sum of total deposits, domestic offices
          only.
        </Typography>

        <Typography variant="body2">Interest Bearing Deposits</Typography>

        <Typography variant="body2">
          - 1934-1991 - Represents any deposit, whether demand, savings or time,
          on which the bank pays or accrues interest. From 1934 to 1973 it
          included only time and savings deposits in domestic offices. From 1974
          to 1983 it includes time and savings deposits in domestic offices and
          all deposits in foreign offices (most, but not all of which are
          interest bearing). From 1984 to the present, interest bearing deposits
          in both domestic and foreign offices are reported values.
        </Typography>

        <Typography variant="body2">
          Memo: Deposits Non-interest Bearing
        </Typography>

        <Typography variant="body2">
          - 1934-present - Represents any deposit on which the bank does not pay
          or accrue interest.
        </Typography>

        <Typography variant="body2">
          NOTE: In the 1991 edition, all deposits in foreign offices were
          included in this column for the years 1974 through 1983. In this
          edition they have been moved to Interest Bearing. See above.
        </Typography>

        <Typography variant="body2">
          Deposits - Domestic Deposits - Demand
        </Typography>

        <Typography variant="body2">
          - 1934-present - Represents all deposits in domestic offices subject
          to withdrawal upon demand.
        </Typography>

        <Typography variant="body2">
          {" "}
          Deposits - Domestic Deposits - Savings
        </Typography>

        <Typography variant="body2">
          - 1934-present - Represents all savings deposits in domestic offices.
        </Typography>

        <Typography variant="body2">
          - 1934-1964 - Includes postal savings deposits.
        </Typography>

        <Typography variant="body2">Deposits - Domestic Time</Typography>

        <Typography variant="body2">- 1961-present -</Typography>

        <Typography variant="body2">
          - 1934-1941 - Represents all time certificates of deposit, time open
          accounts and similar deposits in domestic offices.
        </Typography>

        <Typography variant="body2">
          Memo: Domestic Deposits- Transaction
        </Typography>

        <Typography variant="body2">
          - 1984-present - Represents all demand deposits, NOW accounts, ATS
          accounts, accounts from which payments may be made to third parties by
          means of an automated teller machine, a remote service unit, or
          another electronic device, and accounts that permit third party
          payments through use of checks, drafts, negotiable instruments, or
          other similar instrument. (MMDA's are specifically excluded from the
          latter two definitions).
        </Typography>

        <Typography variant="body2">
          Memo: Domestic Deposits - Non-transaction
        </Typography>

        <Typography variant="body2">
          - 1984-present - Represents deposits that are not included in the
          definition of transaction accounts above or that do not satisfy the
          criteria necessary to be defined as a transaction account. MMDA's are
          specifically defined as non-transaction accounts.
        </Typography>

        <Typography
          variant="h2"
          id="Interest Earning Assets and Interest-Bearing
Liabilities"
        >
          Interest Earning Assets and Interest-Bearing Liabilities
        </Typography>

        <Typography variant="body2">General Comments</Typography>

        <Typography variant="body2">
          0 represents a positive amount less than $500
        </Typography>

        <Typography variant="body2">
          (0) represents a negative amount less than ($500)
        </Typography>

        <Typography variant="body2">NA -Not available</Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. Significant adjustments, changes or definitional differences
          from current requirements are identified or described. Comments
          describing changes in reporting practices relating to assets,
          liabilities and capital items are important in interpreting related
          income and expense items.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">Interest Earning Assets</Typography>

        <Typography variant="body2">
          Assets - Interest Earning Balances - Represents interest income on
          deposit balances maintained with banks and other financial
          institutions.
        </Typography>

        <Typography variant="body2">
          Assets – Total Investment Securities (Book Value) - Represents
          securities of the U.S. Treasury; the U.S. Government, both direct and
          guaranteed; U.S. Government agencies and corporations; obligations of
          states, counties and municipalities; corporate bonds; other bonds,
          notes and debentures and equity securities. The amount is net of
          valuation reserves.
        </Typography>

        <Typography variant="body2">
          Assets - Net Loans and Leases - Represents gross loans and leases less
          unearned income and the allowance for loan and lease losses.
        </Typography>

        <Typography variant="body2">
          Assets - Federal Funds Sold - 1965-present - Represents Federal funds
          sold and securities purchased under agreements to resell.
        </Typography>

        <Typography variant="body2">Trading Account Assets</Typography>

        <Typography variant="body2">
          - 1984-present - Represents all assets held in trading accounts.
        </Typography>

        <Typography variant="body2">
          - 1969-1983 - Represents securities held in trading accounts.
        </Typography>

        <Typography variant="body2">
          - 1934-1968 - Any assets maintained for trading purposes would have
          been included in their respective asset categories.
        </Typography>

        <Typography variant="body2">
          Total Interest Earning Assets - Represents the sum of all
          interest-bearing assets.
        </Typography>

        <Typography variant="body2">Interest Bearing Liabilities</Typography>

        <Typography variant="body2">
          Liabilities - Interest Bearing Deposits
        </Typography>

        <Typography variant="body2">
          - 1974-present - Represents any deposit in domestic and foreign
          offices on which the banks pays or accrues interest.
        </Typography>

        <Typography variant="body2">
          NOTE: The 1991 edition reflected interest bearing deposits in domestic
          offices only for the years 1974 through 1983.
        </Typography>

        <Typography variant="body2">
          - 1934-1973 - Represents any deposit in domestic offices on which the
          bank pays or accrues interest.
        </Typography>

        <Typography variant="body2">
          Liabilities - Federal Funds Purchased/Securities Sold
        </Typography>

        <Typography variant="body2">
          - 1965-present -Represents all Federal funds purchased and securities
          sold under agreements to repurchase.
        </Typography>

        <Typography variant="body2">
          Mortgage and Other Borrowings - 1969-present - Represents mortgage
          indebtedness and liabilities under capitalized leases.
        </Typography>

        <Typography variant="body2">
          Demand Notes and Other Liaibilities - Represents demand notes issued
          to the U.S. Treasury and all other borrowings.
        </Typography>

        <Typography variant="body2">
          Subordinated Notes and Debentures - 1944-present - Represents all
          notes and debentures subordinated to deposits.
        </Typography>

        <Typography variant="body2">
          Total Interest Bearing Liabilities - Represents the sum of all
          interest bearing liabilities.
        </Typography>

        <Typography variant="h2" id="">
          Deposits in Foreign Offices and Past Due and Nonaccrual Loans &amp;
          Leases
        </Typography>

        <Typography variant="body2">General Comments</Typography>

        <Typography variant="body2">
          0 represents a positive amount less than $500
        </Typography>

        <Typography variant="body2">
          (0) represents a negative amount less than ($500)
        </Typography>

        <Typography variant="body2">NA -Not available</Typography>

        <Typography variant="body2">
          Current reporting requirements or definitions for each column heading
          are stated below. Where possible, historical amounts are adjusted to
          reflect current reporting requirements and definitions as closely as
          possible. Significant adjustments, changes or definitional differences
          from current requirements are identified or described. Comments
          describing changes in reporting practices relating to assets,
          liabilities and capital items are important in interpreting related
          income and expense items.
        </Typography>

        <Typography variant="body2">Field Content</Typography>

        <Typography variant="body2">
          Foreign Deposits - Interest Bearing
        </Typography>

        <Typography variant="body2">
          - 1984-present - Represents any deposit in foreign offices, whether
          demand, savings or time, on which the bank pays or accrues interest.
        </Typography>

        <Typography variant="body2">
          - 1974-1983 - The actual breakdown between interest and noninterest
          bearing is not available. As can be seen in later years, most of the
          deposits are interest bearing.
        </Typography>

        <Typography variant="body2">
          Foreign Deposits - Noninterest Bearing
        </Typography>

        <Typography variant="body2">
          - 1984-present - Represents any deposit in foreign offices on which
          the bank does not pay or accrue interest.
        </Typography>

        <Typography variant="body2">
          Total Foreign Deposits - Represents the sum of total deposits in
          foreign offices.
        </Typography>

        <Typography variant="body2">
          Loans and Leases Past Due 30-89 Days
        </Typography>

        <Typography variant="body2">
          - 1984-present - Represents all loans and leases that are 30-89 days
          past due.
        </Typography>

        <Typography variant="body2">
          Loans and Leases Past Due 90 Days or More
        </Typography>

        <Typography variant="body2">
          - 1984-present - Represents all loans and leases that are 90 days or
          more past due.
        </Typography>

        <Typography variant="body2">Total Loans and Leases Past Due</Typography>

        <Typography variant="body2">
          Total Non-accrual Loans and Leases
        </Typography>

        <Typography variant="body2">
          - 1984-present - Represents all loans and leases that (a) are
          maintained on a cash basis because of deterioration in the financial
          position of the borrower, (b) payment in full of interest and
          principal is not expected or (c) principal or interest has been in
          default for a period of 90 days or more unless the obligation is both
          well secured and in the process of collection.
        </Typography>

        <Typography variant="body2">
          NOTE: The column labeled Nonaccrual Loans &amp; Leases in the 1991
          edition should have been labeled Noncurrent Loans and Leases.
        </Typography>

        <Typography variant="body2">
          Total Non-current Loans and Leases
        </Typography>

        <Typography variant="body2">
          - 1984-present - Represents all loans and leases past due 90 days or
          more and still accruing plus all loans and leases in a nonaccrual
          status.
        </Typography>
      </>
    </>
  );
}
